function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Plugin, PluginKey, TextSelection, Selection, NodeSelection, EditorState } from '@tiptap/pm/state';
import { EditorView } from '@tiptap/pm/view';
import { keymap } from '@tiptap/pm/keymap';
import { Schema, Fragment, DOMParser, DOMSerializer, Node as Node$1, Slice } from '@tiptap/pm/model';
import { liftTarget, ReplaceStep, ReplaceAroundStep, joinPoint, Transform, canSplit, canJoin, findWrapping } from '@tiptap/pm/transform';
import { createParagraphNear as createParagraphNear$1, deleteSelection as deleteSelection$1, exitCode as exitCode$1, joinUp as joinUp$1, joinDown as joinDown$1, joinBackward as joinBackward$1, joinForward as joinForward$1, lift as lift$1, liftEmptyBlock as liftEmptyBlock$1, newlineInCode as newlineInCode$1, selectNodeBackward as selectNodeBackward$1, selectNodeForward as selectNodeForward$1, selectParentNode as selectParentNode$1, selectTextblockEnd as selectTextblockEnd$1, selectTextblockStart as selectTextblockStart$1, setBlockType, wrapIn as wrapIn$1 } from '@tiptap/pm/commands';
import { liftListItem as liftListItem$1, sinkListItem as sinkListItem$1, wrapInList as wrapInList$1 } from '@tiptap/pm/schema-list';

function createChainableState(config) {
  var state = config.state,
      transaction = config.transaction;
  var selection = transaction.selection;
  var doc = transaction.doc;
  var storedMarks = transaction.storedMarks;
  return _objectSpread(_objectSpread({}, state), {}, {
    apply: state.apply.bind(state),
    applyTransaction: state.applyTransaction.bind(state),
    filterTransaction: state.filterTransaction,
    plugins: state.plugins,
    schema: state.schema,
    reconfigure: state.reconfigure.bind(state),
    toJSON: state.toJSON.bind(state),

    get storedMarks() {
      return storedMarks;
    },

    get selection() {
      return selection;
    },

    get doc() {
      return doc;
    },

    get tr() {
      selection = transaction.selection;
      doc = transaction.doc;
      storedMarks = transaction.storedMarks;
      return transaction;
    }

  });
}

var CommandManager = /*#__PURE__*/function () {
  function CommandManager(props) {
    _classCallCheck(this, CommandManager);

    this.editor = props.editor;
    this.rawCommands = this.editor.extensionManager.commands;
    this.customState = props.state;
  }

  _createClass(CommandManager, [{
    key: "hasCustomState",
    get: function get() {
      return !!this.customState;
    }
  }, {
    key: "state",
    get: function get() {
      return this.customState || this.editor.state;
    }
  }, {
    key: "commands",
    get: function get() {
      var _this = this;

      var rawCommands = this.rawCommands,
          editor = this.editor,
          state = this.state;
      var view = editor.view;
      var tr = state.tr;
      var props = this.buildProps(tr);
      return Object.fromEntries(Object.entries(rawCommands).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            command = _ref2[1];

        var method = function method() {
          var callback = command.apply(void 0, arguments)(props);

          if (!tr.getMeta('preventDispatch') && !_this.hasCustomState) {
            view.dispatch(tr);
          }

          return callback;
        };

        return [name, method];
      }));
    }
  }, {
    key: "chain",
    get: function get() {
      var _this2 = this;

      return function () {
        return _this2.createChain();
      };
    }
  }, {
    key: "can",
    get: function get() {
      var _this3 = this;

      return function () {
        return _this3.createCan();
      };
    }
  }, {
    key: "createChain",
    value: function createChain(startTr) {
      var _this4 = this;

      var shouldDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rawCommands = this.rawCommands,
          editor = this.editor,
          state = this.state;
      var view = editor.view;
      var callbacks = [];
      var hasStartTransaction = !!startTr;
      var tr = startTr || state.tr;

      var run = function run() {
        if (!hasStartTransaction && shouldDispatch && !tr.getMeta('preventDispatch') && !_this4.hasCustomState) {
          view.dispatch(tr);
        }

        return callbacks.every(function (callback) {
          return callback === true;
        });
      };

      var chain = _objectSpread(_objectSpread({}, Object.fromEntries(Object.entries(rawCommands).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            command = _ref4[1];

        var chainedCommand = function chainedCommand() {
          var props = _this4.buildProps(tr, shouldDispatch);

          var callback = command.apply(void 0, arguments)(props);
          callbacks.push(callback);
          return chain;
        };

        return [name, chainedCommand];
      }))), {}, {
        run: run
      });

      return chain;
    }
  }, {
    key: "createCan",
    value: function createCan(startTr) {
      var _this5 = this;

      var rawCommands = this.rawCommands,
          state = this.state;
      var dispatch = false;
      var tr = startTr || state.tr;
      var props = this.buildProps(tr, dispatch);
      var formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            name = _ref6[0],
            command = _ref6[1];

        return [name, function () {
          return command.apply(void 0, arguments)(_objectSpread(_objectSpread({}, props), {}, {
            dispatch: undefined
          }));
        }];
      }));
      return _objectSpread(_objectSpread({}, formattedCommands), {}, {
        chain: function chain() {
          return _this5.createChain(tr, dispatch);
        }
      });
    }
  }, {
    key: "buildProps",
    value: function buildProps(tr) {
      var _this6 = this;

      var shouldDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rawCommands = this.rawCommands,
          editor = this.editor,
          state = this.state;
      var view = editor.view;
      var props = {
        tr: tr,
        editor: editor,
        view: view,
        state: createChainableState({
          state: state,
          transaction: tr
        }),
        dispatch: shouldDispatch ? function () {
          return undefined;
        } : undefined,
        chain: function chain() {
          return _this6.createChain(tr, shouldDispatch);
        },
        can: function can() {
          return _this6.createCan(tr);
        },

        get commands() {
          return Object.fromEntries(Object.entries(rawCommands).map(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
                name = _ref8[0],
                command = _ref8[1];

            return [name, function () {
              return command.apply(void 0, arguments)(props);
            }];
          }));
        }

      };
      return props;
    }
  }]);

  return CommandManager;
}();

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.callbacks = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, fn) {
      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }

      this.callbacks[event].push(fn);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this7 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var callbacks = this.callbacks[event];

      if (callbacks) {
        callbacks.forEach(function (callback) {
          return callback.apply(_this7, args);
        });
      }

      return this;
    }
  }, {
    key: "off",
    value: function off(event, fn) {
      var callbacks = this.callbacks[event];

      if (callbacks) {
        if (fn) {
          this.callbacks[event] = callbacks.filter(function (callback) {
            return callback !== fn;
          });
        } else {
          delete this.callbacks[event];
        }
      }

      return this;
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners() {
      this.callbacks = {};
    }
  }]);

  return EventEmitter;
}();

function getExtensionField(extension, field, context) {
  if (extension.config[field] === undefined && extension.parent) {
    return getExtensionField(extension.parent, field, context);
  }

  if (typeof extension.config[field] === 'function') {
    var value = extension.config[field].bind(_objectSpread(_objectSpread({}, context), {}, {
      parent: extension.parent ? getExtensionField(extension.parent, field, context) : null
    }));
    return value;
  }

  return extension.config[field];
}

function splitExtensions(extensions) {
  var baseExtensions = extensions.filter(function (extension) {
    return extension.type === 'extension';
  });
  var nodeExtensions = extensions.filter(function (extension) {
    return extension.type === 'node';
  });
  var markExtensions = extensions.filter(function (extension) {
    return extension.type === 'mark';
  });
  return {
    baseExtensions: baseExtensions,
    nodeExtensions: nodeExtensions,
    markExtensions: markExtensions
  };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */


function getAttributesFromExtensions(extensions) {
  var extensionAttributes = [];

  var _splitExtensions = splitExtensions(extensions),
      nodeExtensions = _splitExtensions.nodeExtensions,
      markExtensions = _splitExtensions.markExtensions;

  var nodeAndMarkExtensions = [].concat(_toConsumableArray(nodeExtensions), _toConsumableArray(markExtensions));
  var defaultAttribute = {
    default: null,
    rendered: true,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: true,
    isRequired: false
  };
  extensions.forEach(function (extension) {
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage
    };
    var addGlobalAttributes = getExtensionField(extension, 'addGlobalAttributes', context);

    if (!addGlobalAttributes) {
      return;
    } // TODO: remove `as GlobalAttributes`


    var globalAttributes = addGlobalAttributes();
    globalAttributes.forEach(function (globalAttribute) {
      globalAttribute.types.forEach(function (type) {
        Object.entries(globalAttribute.attributes).forEach(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              name = _ref10[0],
              attribute = _ref10[1];

          extensionAttributes.push({
            type: type,
            name: name,
            attribute: _objectSpread(_objectSpread({}, defaultAttribute), attribute)
          });
        });
      });
    });
  });
  nodeAndMarkExtensions.forEach(function (extension) {
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage
    };
    var addAttributes = getExtensionField(extension, 'addAttributes', context);

    if (!addAttributes) {
      return;
    } // TODO: remove `as Attributes`


    var attributes = addAttributes();
    Object.entries(attributes).forEach(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          name = _ref12[0],
          attribute = _ref12[1];

      var mergedAttr = _objectSpread(_objectSpread({}, defaultAttribute), attribute);

      if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') {
        mergedAttr.default = mergedAttr.default();
      }

      if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) {
        delete mergedAttr.default;
      }

      extensionAttributes.push({
        type: extension.name,
        name: name,
        attribute: mergedAttr
      });
    });
  });
  return extensionAttributes;
}

function getNodeType(nameOrType, schema) {
  if (typeof nameOrType === 'string') {
    if (!schema.nodes[nameOrType]) {
      throw Error("There is no node type named '".concat(nameOrType, "'. Maybe you forgot to add the extension?"));
    }

    return schema.nodes[nameOrType];
  }

  return nameOrType;
}

function mergeAttributes() {
  for (var _len2 = arguments.length, objects = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    objects[_key2] = arguments[_key2];
  }

  return objects.filter(function (item) {
    return !!item;
  }).reduce(function (items, item) {
    var mergedAttributes = _objectSpread({}, items);

    Object.entries(item).forEach(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
          key = _ref14[0],
          value = _ref14[1];

      var exists = mergedAttributes[key];

      if (!exists) {
        mergedAttributes[key] = value;
        return;
      }

      if (key === 'class') {
        var valueClasses = value ? value.split(' ') : [];
        var existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
        var insertClasses = valueClasses.filter(function (valueClass) {
          return !existingClasses.includes(valueClass);
        });
        mergedAttributes[key] = [].concat(_toConsumableArray(existingClasses), _toConsumableArray(insertClasses)).join(' ');
      } else if (key === 'style') {
        mergedAttributes[key] = [mergedAttributes[key], value].join('; ');
      } else {
        mergedAttributes[key] = value;
      }
    });
    return mergedAttributes;
  }, {});
}

function getRenderedAttributes(nodeOrMark, extensionAttributes) {
  return extensionAttributes.filter(function (item) {
    return item.attribute.rendered;
  }).map(function (item) {
    if (!item.attribute.renderHTML) {
      return _defineProperty({}, item.name, nodeOrMark.attrs[item.name]);
    }

    return item.attribute.renderHTML(nodeOrMark.attrs) || {};
  }).reduce(function (attributes, attribute) {
    return mergeAttributes(attributes, attribute);
  }, {});
}

function isFunction(value) {
  return typeof value === 'function';
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */


function callOrReturn(value) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (isFunction(value)) {
    for (var _len3 = arguments.length, props = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      props[_key3 - 2] = arguments[_key3];
    }

    if (context) {
      return value.bind(context).apply(void 0, props);
    }

    return value.apply(void 0, props);
  }

  return value;
}

function isEmptyObject() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(value).length === 0 && value.constructor === Object;
}

function fromString(value) {
  if (typeof value !== 'string') {
    return value;
  }

  if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
    return Number(value);
  }

  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */


function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
  if (parseRule.style) {
    return parseRule;
  }

  return _objectSpread(_objectSpread({}, parseRule), {}, {
    getAttrs: function getAttrs(node) {
      var oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;

      if (oldAttributes === false) {
        return false;
      }

      var newAttributes = extensionAttributes.reduce(function (items, item) {
        var value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : fromString(node.getAttribute(item.name));

        if (value === null || value === undefined) {
          return items;
        }

        return _objectSpread(_objectSpread({}, items), {}, _defineProperty({}, item.name, value));
      }, {});
      return _objectSpread(_objectSpread({}, oldAttributes), newAttributes);
    }
  });
}

function cleanUpSchemaItem(data) {
  return Object.fromEntries( // @ts-ignore
  Object.entries(data).filter(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
        key = _ref17[0],
        value = _ref17[1];

    if (key === 'attrs' && isEmptyObject(value)) {
      return false;
    }

    return value !== null && value !== undefined;
  }));
}

function getSchemaByResolvedExtensions(extensions, editor) {
  var _a;

  var allAttributes = getAttributesFromExtensions(extensions);

  var _splitExtensions2 = splitExtensions(extensions),
      nodeExtensions = _splitExtensions2.nodeExtensions,
      markExtensions = _splitExtensions2.markExtensions;

  var topNode = (_a = nodeExtensions.find(function (extension) {
    return getExtensionField(extension, 'topNode');
  })) === null || _a === void 0 ? void 0 : _a.name;
  var nodes = Object.fromEntries(nodeExtensions.map(function (extension) {
    var extensionAttributes = allAttributes.filter(function (attribute) {
      return attribute.type === extension.name;
    });
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage,
      editor: editor
    };
    var extraNodeFields = extensions.reduce(function (fields, e) {
      var extendNodeSchema = getExtensionField(e, 'extendNodeSchema', context);
      return _objectSpread(_objectSpread({}, fields), extendNodeSchema ? extendNodeSchema(extension) : {});
    }, {});
    var schema = cleanUpSchemaItem(_objectSpread(_objectSpread({}, extraNodeFields), {}, {
      content: callOrReturn(getExtensionField(extension, 'content', context)),
      marks: callOrReturn(getExtensionField(extension, 'marks', context)),
      group: callOrReturn(getExtensionField(extension, 'group', context)),
      inline: callOrReturn(getExtensionField(extension, 'inline', context)),
      atom: callOrReturn(getExtensionField(extension, 'atom', context)),
      selectable: callOrReturn(getExtensionField(extension, 'selectable', context)),
      draggable: callOrReturn(getExtensionField(extension, 'draggable', context)),
      code: callOrReturn(getExtensionField(extension, 'code', context)),
      defining: callOrReturn(getExtensionField(extension, 'defining', context)),
      isolating: callOrReturn(getExtensionField(extension, 'isolating', context)),
      attrs: Object.fromEntries(extensionAttributes.map(function (extensionAttribute) {
        var _a;

        return [extensionAttribute.name, {
          default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
        }];
      }))
    }));
    var parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));

    if (parseHTML) {
      schema.parseDOM = parseHTML.map(function (parseRule) {
        return injectExtensionAttributesToParseRule(parseRule, extensionAttributes);
      });
    }

    var renderHTML = getExtensionField(extension, 'renderHTML', context);

    if (renderHTML) {
      schema.toDOM = function (node) {
        return renderHTML({
          node: node,
          HTMLAttributes: getRenderedAttributes(node, extensionAttributes)
        });
      };
    }

    var renderText = getExtensionField(extension, 'renderText', context);

    if (renderText) {
      schema.toText = renderText;
    }

    return [extension.name, schema];
  }));
  var marks = Object.fromEntries(markExtensions.map(function (extension) {
    var extensionAttributes = allAttributes.filter(function (attribute) {
      return attribute.type === extension.name;
    });
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage,
      editor: editor
    };
    var extraMarkFields = extensions.reduce(function (fields, e) {
      var extendMarkSchema = getExtensionField(e, 'extendMarkSchema', context);
      return _objectSpread(_objectSpread({}, fields), extendMarkSchema ? extendMarkSchema(extension) : {});
    }, {});
    var schema = cleanUpSchemaItem(_objectSpread(_objectSpread({}, extraMarkFields), {}, {
      inclusive: callOrReturn(getExtensionField(extension, 'inclusive', context)),
      excludes: callOrReturn(getExtensionField(extension, 'excludes', context)),
      group: callOrReturn(getExtensionField(extension, 'group', context)),
      spanning: callOrReturn(getExtensionField(extension, 'spanning', context)),
      code: callOrReturn(getExtensionField(extension, 'code', context)),
      attrs: Object.fromEntries(extensionAttributes.map(function (extensionAttribute) {
        var _a;

        return [extensionAttribute.name, {
          default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
        }];
      }))
    }));
    var parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));

    if (parseHTML) {
      schema.parseDOM = parseHTML.map(function (parseRule) {
        return injectExtensionAttributesToParseRule(parseRule, extensionAttributes);
      });
    }

    var renderHTML = getExtensionField(extension, 'renderHTML', context);

    if (renderHTML) {
      schema.toDOM = function (mark) {
        return renderHTML({
          mark: mark,
          HTMLAttributes: getRenderedAttributes(mark, extensionAttributes)
        });
      };
    }

    return [extension.name, schema];
  }));
  return new Schema({
    topNode: topNode,
    nodes: nodes,
    marks: marks
  });
}

function getSchemaTypeByName(name, schema) {
  return schema.nodes[name] || schema.marks[name] || null;
}

function isExtensionRulesEnabled(extension, enabled) {
  if (Array.isArray(enabled)) {
    return enabled.some(function (enabledExtension) {
      var name = typeof enabledExtension === 'string' ? enabledExtension : enabledExtension.name;
      return name === extension.name;
    });
  }

  return enabled;
}

var getTextContentFromNodes = function getTextContentFromNodes($from) {
  var maxMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var textBefore = '';
  var sliceEndPos = $from.parentOffset;
  $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, function (node, pos, parent, index) {
    var _a, _b;

    var chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
      node: node,
      pos: pos,
      parent: parent,
      index: index
    })) || node.textContent || '%leaf%';
    textBefore += chunk.slice(0, Math.max(0, sliceEndPos - pos));
  });
  return textBefore;
};

function isRegExp(value) {
  return Object.prototype.toString.call(value) === '[object RegExp]';
}

var InputRule = /*#__PURE__*/_createClass(function InputRule(config) {
  _classCallCheck(this, InputRule);

  this.find = config.find;
  this.handler = config.handler;
});

var inputRuleMatcherHandler = function inputRuleMatcherHandler(text, find) {
  if (isRegExp(find)) {
    return find.exec(text);
  }

  var inputRuleMatch = find(text);

  if (!inputRuleMatch) {
    return null;
  }

  var result = [inputRuleMatch.text];
  result.index = inputRuleMatch.index;
  result.input = text;
  result.data = inputRuleMatch.data;

  if (inputRuleMatch.replaceWith) {
    if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
      console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
    }

    result.push(inputRuleMatch.replaceWith);
  }

  return result;
};

function run$1(config) {
  var _a;

  var editor = config.editor,
      from = config.from,
      to = config.to,
      text = config.text,
      rules = config.rules,
      plugin = config.plugin;
  var view = editor.view;

  if (view.composing) {
    return false;
  }

  var $from = view.state.doc.resolve(from);

  if ( // check for code node
  $from.parent.type.spec.code // check for code mark
  || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find(function (mark) {
    return mark.type.spec.code;
  }))) {
    return false;
  }

  var matched = false;
  var textBefore = getTextContentFromNodes($from) + text;
  rules.forEach(function (rule) {
    if (matched) {
      return;
    }

    var match = inputRuleMatcherHandler(textBefore, rule.find);

    if (!match) {
      return;
    }

    var tr = view.state.tr;
    var state = createChainableState({
      state: view.state,
      transaction: tr
    });
    var range = {
      from: from - (match[0].length - text.length),
      to: to
    };

    var _CommandManager = new CommandManager({
      editor: editor,
      state: state
    }),
        commands = _CommandManager.commands,
        chain = _CommandManager.chain,
        can = _CommandManager.can;

    var handler = rule.handler({
      state: state,
      range: range,
      match: match,
      commands: commands,
      chain: chain,
      can: can
    }); // stop if there are no changes

    if (handler === null || !tr.steps.length) {
      return;
    } // store transform as meta data
    // so we can undo input rules within the `undoInputRules` command


    tr.setMeta(plugin, {
      transform: tr,
      from: from,
      to: to,
      text: text
    });
    view.dispatch(tr);
    matched = true;
  });
  return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */


function inputRulesPlugin(props) {
  var editor = props.editor,
      rules = props.rules;
  var plugin = new Plugin({
    state: {
      init: function init() {
        return null;
      },
      apply: function apply(tr, prev) {
        var stored = tr.getMeta(plugin);

        if (stored) {
          return stored;
        }

        return tr.selectionSet || tr.docChanged ? null : prev;
      }
    },
    props: {
      handleTextInput: function handleTextInput(view, from, to, text) {
        return run$1({
          editor: editor,
          from: from,
          to: to,
          text: text,
          rules: rules,
          plugin: plugin
        });
      },
      handleDOMEvents: {
        compositionend: function compositionend(view) {
          setTimeout(function () {
            var $cursor = view.state.selection.$cursor;

            if ($cursor) {
              run$1({
                editor: editor,
                from: $cursor.pos,
                to: $cursor.pos,
                text: '',
                rules: rules,
                plugin: plugin
              });
            }
          });
          return false;
        }
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown: function handleKeyDown(view, event) {
        if (event.key !== 'Enter') {
          return false;
        }

        var $cursor = view.state.selection.$cursor;

        if ($cursor) {
          return run$1({
            editor: editor,
            from: $cursor.pos,
            to: $cursor.pos,
            text: '\n',
            rules: rules,
            plugin: plugin
          });
        }

        return false;
      }
    },
    // @ts-ignore
    isInputRules: true
  });
  return plugin;
}

function isNumber(value) {
  return typeof value === 'number';
}

var PasteRule = /*#__PURE__*/_createClass(function PasteRule(config) {
  _classCallCheck(this, PasteRule);

  this.find = config.find;
  this.handler = config.handler;
});

var pasteRuleMatcherHandler = function pasteRuleMatcherHandler(text, find) {
  if (isRegExp(find)) {
    return _toConsumableArray(text.matchAll(find));
  }

  var matches = find(text);

  if (!matches) {
    return [];
  }

  return matches.map(function (pasteRuleMatch) {
    var result = [pasteRuleMatch.text];
    result.index = pasteRuleMatch.index;
    result.input = text;
    result.data = pasteRuleMatch.data;

    if (pasteRuleMatch.replaceWith) {
      if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
        console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
      }

      result.push(pasteRuleMatch.replaceWith);
    }

    return result;
  });
};

function run(config) {
  var editor = config.editor,
      state = config.state,
      from = config.from,
      to = config.to,
      rule = config.rule;

  var _CommandManager2 = new CommandManager({
    editor: editor,
    state: state
  }),
      commands = _CommandManager2.commands,
      chain = _CommandManager2.chain,
      can = _CommandManager2.can;

  var handlers = [];
  state.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isTextblock || node.type.spec.code) {
      return;
    }

    var resolvedFrom = Math.max(from, pos);
    var resolvedTo = Math.min(to, pos + node.content.size);
    var textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, "\uFFFC");
    var matches = pasteRuleMatcherHandler(textToMatch, rule.find);
    matches.forEach(function (match) {
      if (match.index === undefined) {
        return;
      }

      var start = resolvedFrom + match.index + 1;
      var end = start + match[0].length;
      var range = {
        from: state.tr.mapping.map(start),
        to: state.tr.mapping.map(end)
      };
      var handler = rule.handler({
        state: state,
        range: range,
        match: match,
        commands: commands,
        chain: chain,
        can: can
      });
      handlers.push(handler);
    });
  });
  var success = handlers.every(function (handler) {
    return handler !== null;
  });
  return success;
}
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */


function pasteRulesPlugin(props) {
  var editor = props.editor,
      rules = props.rules;
  var dragSourceElement = null;
  var isPastedFromProseMirror = false;
  var isDroppedFromProseMirror = false;
  var plugins = rules.map(function (rule) {
    return new Plugin({
      // we register a global drag handler to track the current drag source element
      view: function view(_view) {
        var handleDragstart = function handleDragstart(event) {
          var _a;

          dragSourceElement = ((_a = _view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? _view.dom.parentElement : null;
        };

        window.addEventListener('dragstart', handleDragstart);
        return {
          destroy: function destroy() {
            window.removeEventListener('dragstart', handleDragstart);
          }
        };
      },
      props: {
        handleDOMEvents: {
          drop: function drop(view) {
            isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
            return false;
          },
          paste: function paste(view, event) {
            var _a;

            var html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
            isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
            return false;
          }
        }
      },
      appendTransaction: function appendTransaction(transactions, oldState, state) {
        var transaction = transactions[0];
        var isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
        var isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;

        if (!isPaste && !isDrop) {
          return;
        } // stop if there is no changed range


        var from = oldState.doc.content.findDiffStart(state.doc.content);
        var to = oldState.doc.content.findDiffEnd(state.doc.content);

        if (!isNumber(from) || !to || from === to.b) {
          return;
        } // build a chainable state
        // so we can use a single transaction for all paste rules


        var tr = state.tr;
        var chainableState = createChainableState({
          state: state,
          transaction: tr
        });
        var handler = run({
          editor: editor,
          state: chainableState,
          from: Math.max(from - 1, 0),
          to: to.b - 1,
          rule: rule
        }); // stop if there are no changes

        if (!handler || !tr.steps.length) {
          return;
        }

        return tr;
      }
    });
  });
  return plugins;
}

function findDuplicates(items) {
  var filtered = items.filter(function (el, index) {
    return items.indexOf(el) !== index;
  });
  return _toConsumableArray(new Set(filtered));
}

var ExtensionManager = /*#__PURE__*/function () {
  function ExtensionManager(extensions, editor) {
    var _this8 = this;

    _classCallCheck(this, ExtensionManager);

    this.splittableMarks = [];
    this.editor = editor;
    this.extensions = ExtensionManager.resolve(extensions);
    this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
    this.extensions.forEach(function (extension) {
      var _a; // store extension storage in editor


      _this8.editor.extensionStorage[extension.name] = extension.storage;
      var context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
        editor: _this8.editor,
        type: getSchemaTypeByName(extension.name, _this8.schema)
      };

      if (extension.type === 'mark') {
        var keepOnSplit = (_a = callOrReturn(getExtensionField(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;

        if (keepOnSplit) {
          _this8.splittableMarks.push(extension.name);
        }
      }

      var onBeforeCreate = getExtensionField(extension, 'onBeforeCreate', context);

      if (onBeforeCreate) {
        _this8.editor.on('beforeCreate', onBeforeCreate);
      }

      var onCreate = getExtensionField(extension, 'onCreate', context);

      if (onCreate) {
        _this8.editor.on('create', onCreate);
      }

      var onUpdate = getExtensionField(extension, 'onUpdate', context);

      if (onUpdate) {
        _this8.editor.on('update', onUpdate);
      }

      var onSelectionUpdate = getExtensionField(extension, 'onSelectionUpdate', context);

      if (onSelectionUpdate) {
        _this8.editor.on('selectionUpdate', onSelectionUpdate);
      }

      var onTransaction = getExtensionField(extension, 'onTransaction', context);

      if (onTransaction) {
        _this8.editor.on('transaction', onTransaction);
      }

      var onFocus = getExtensionField(extension, 'onFocus', context);

      if (onFocus) {
        _this8.editor.on('focus', onFocus);
      }

      var onBlur = getExtensionField(extension, 'onBlur', context);

      if (onBlur) {
        _this8.editor.on('blur', onBlur);
      }

      var onDestroy = getExtensionField(extension, 'onDestroy', context);

      if (onDestroy) {
        _this8.editor.on('destroy', onDestroy);
      }
    });
  }

  _createClass(ExtensionManager, [{
    key: "commands",
    get: function get() {
      var _this9 = this;

      return this.extensions.reduce(function (commands, extension) {
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: _this9.editor,
          type: getSchemaTypeByName(extension.name, _this9.schema)
        };
        var addCommands = getExtensionField(extension, 'addCommands', context);

        if (!addCommands) {
          return commands;
        }

        return _objectSpread(_objectSpread({}, commands), addCommands());
      }, {});
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this10 = this;

      var editor = this.editor; // With ProseMirror, first plugins within an array are executed first.
      // In Tiptap, we provide the ability to override plugins,
      // so it feels more natural to run plugins at the end of an array first.
      // That’s why we have to reverse the `extensions` array and sort again
      // based on the `priority` option.

      var extensions = ExtensionManager.sort(_toConsumableArray(this.extensions).reverse());
      var inputRules = [];
      var pasteRules = [];
      var allPlugins = extensions.map(function (extension) {
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: editor,
          type: getSchemaTypeByName(extension.name, _this10.schema)
        };
        var plugins = [];
        var addKeyboardShortcuts = getExtensionField(extension, 'addKeyboardShortcuts', context);
        var defaultBindings = {}; // bind exit handling

        if (extension.type === 'mark' && extension.config.exitable) {
          defaultBindings.ArrowRight = function () {
            return Mark.handleExit({
              editor: editor,
              mark: extension
            });
          };
        }

        if (addKeyboardShortcuts) {
          var bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(function (_ref18) {
            var _ref19 = _slicedToArray(_ref18, 2),
                shortcut = _ref19[0],
                method = _ref19[1];

            return [shortcut, function () {
              return method({
                editor: editor
              });
            }];
          }));
          defaultBindings = _objectSpread(_objectSpread({}, defaultBindings), bindings);
        }

        var keyMapPlugin = keymap(defaultBindings);
        plugins.push(keyMapPlugin);
        var addInputRules = getExtensionField(extension, 'addInputRules', context);

        if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
          inputRules.push.apply(inputRules, _toConsumableArray(addInputRules()));
        }

        var addPasteRules = getExtensionField(extension, 'addPasteRules', context);

        if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
          pasteRules.push.apply(pasteRules, _toConsumableArray(addPasteRules()));
        }

        var addProseMirrorPlugins = getExtensionField(extension, 'addProseMirrorPlugins', context);

        if (addProseMirrorPlugins) {
          var proseMirrorPlugins = addProseMirrorPlugins();
          plugins.push.apply(plugins, _toConsumableArray(proseMirrorPlugins));
        }

        return plugins;
      }).flat();
      return [inputRulesPlugin({
        editor: editor,
        rules: inputRules
      })].concat(_toConsumableArray(pasteRulesPlugin({
        editor: editor,
        rules: pasteRules
      })), _toConsumableArray(allPlugins));
    }
  }, {
    key: "attributes",
    get: function get() {
      return getAttributesFromExtensions(this.extensions);
    }
  }, {
    key: "nodeViews",
    get: function get() {
      var _this11 = this;

      var editor = this.editor;

      var _splitExtensions3 = splitExtensions(this.extensions),
          nodeExtensions = _splitExtensions3.nodeExtensions;

      return Object.fromEntries(nodeExtensions.filter(function (extension) {
        return !!getExtensionField(extension, 'addNodeView');
      }).map(function (extension) {
        var extensionAttributes = _this11.attributes.filter(function (attribute) {
          return attribute.type === extension.name;
        });

        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: editor,
          type: getNodeType(extension.name, _this11.schema)
        };
        var addNodeView = getExtensionField(extension, 'addNodeView', context);

        if (!addNodeView) {
          return [];
        }

        var nodeview = function nodeview(node, view, getPos, decorations) {
          var HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
          return addNodeView()({
            editor: editor,
            node: node,
            getPos: getPos,
            decorations: decorations,
            HTMLAttributes: HTMLAttributes,
            extension: extension
          });
        };

        return [extension.name, nodeview];
      }));
    }
  }], [{
    key: "resolve",
    value: function resolve(extensions) {
      var resolvedExtensions = ExtensionManager.sort(ExtensionManager.flatten(extensions));
      var duplicatedNames = findDuplicates(resolvedExtensions.map(function (extension) {
        return extension.name;
      }));

      if (duplicatedNames.length) {
        console.warn("[tiptap warn]: Duplicate extension names found: [".concat(duplicatedNames.map(function (item) {
          return "'".concat(item, "'");
        }).join(', '), "]. This can lead to issues."));
      }

      return resolvedExtensions;
    }
  }, {
    key: "flatten",
    value: function flatten(extensions) {
      var _this12 = this;

      return extensions.map(function (extension) {
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage
        };
        var addExtensions = getExtensionField(extension, 'addExtensions', context);

        if (addExtensions) {
          return [extension].concat(_toConsumableArray(_this12.flatten(addExtensions())));
        }

        return extension;
      }) // `Infinity` will break TypeScript so we set a number that is probably high enough
      .flat(10);
    }
  }, {
    key: "sort",
    value: function sort(extensions) {
      var defaultPriority = 100;
      return extensions.sort(function (a, b) {
        var priorityA = getExtensionField(a, 'priority') || defaultPriority;
        var priorityB = getExtensionField(b, 'priority') || defaultPriority;

        if (priorityA > priorityB) {
          return -1;
        }

        if (priorityA < priorityB) {
          return 1;
        }

        return 0;
      });
    }
  }]);

  return ExtensionManager;
}(); // see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts


function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}

function isPlainObject(value) {
  if (getType(value) !== 'Object') {
    return false;
  }

  return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

function mergeDeep(target, source) {
  var output = _objectSpread({}, target);

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isPlainObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, _defineProperty({}, key, source[key]));
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, _defineProperty({}, key, source[key]));
      }
    });
  }

  return output;
}

var Extension = /*#__PURE__*/function () {
  function Extension() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Extension);

    this.type = 'extension';
    this.name = 'extension';
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.name = this.config.name;

    if (config.defaultOptions) {
      console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(this.name, "\"."));
    } // TODO: remove `addOptions` fallback


    this.options = this.config.defaultOptions;

    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, 'addOptions', {
        name: this.name
      }));
    }

    this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
      name: this.name,
      options: this.options
    })) || {};
  }

  _createClass(Extension, [{
    key: "configure",
    value: function configure() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // return a new instance so we can use the same extension
      // with different calls of `configure`
      var extension = this.extend();
      extension.options = mergeDeep(this.options, options);
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extendedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extension = new Extension(extendedConfig);
      extension.parent = this;
      this.child = extension;
      extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;

      if (extendedConfig.defaultOptions) {
        console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(extension.name, "\"."));
      }

      extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
        name: extension.name
      }));
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }], [{
    key: "create",
    value: function create() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Extension(config);
    }
  }]);

  return Extension;
}();

function getTextBetween(startNode, range, options) {
  var from = range.from,
      to = range.to;

  var _ref20 = options || {},
      _ref20$blockSeparator = _ref20.blockSeparator,
      blockSeparator = _ref20$blockSeparator === void 0 ? '\n\n' : _ref20$blockSeparator,
      _ref20$textSerializer = _ref20.textSerializers,
      textSerializers = _ref20$textSerializer === void 0 ? {} : _ref20$textSerializer;

  var text = '';
  var separated = true;
  startNode.nodesBetween(from, to, function (node, pos, parent, index) {
    var _a;

    var textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];

    if (textSerializer) {
      if (node.isBlock && !separated) {
        text += blockSeparator;
        separated = true;
      }

      if (parent) {
        text += textSerializer({
          node: node,
          pos: pos,
          parent: parent,
          index: index,
          range: range
        });
      }
    } else if (node.isText) {
      text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line

      separated = false;
    } else if (node.isBlock && !separated) {
      text += blockSeparator;
      separated = true;
    }
  });
  return text;
}

function getTextSerializersFromSchema(schema) {
  return Object.fromEntries(Object.entries(schema.nodes).filter(function (_ref21) {
    var _ref22 = _slicedToArray(_ref21, 2),
        node = _ref22[1];

    return node.spec.toText;
  }).map(function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
        name = _ref24[0],
        node = _ref24[1];

    return [name, node.spec.toText];
  }));
}

var ClipboardTextSerializer = Extension.create({
  name: 'clipboardTextSerializer',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this13 = this;

    return [new Plugin({
      key: new PluginKey('clipboardTextSerializer'),
      props: {
        clipboardTextSerializer: function clipboardTextSerializer() {
          var editor = _this13.editor;
          var state = editor.state,
              schema = editor.schema;
          var doc = state.doc,
              selection = state.selection;
          var ranges = selection.ranges;
          var from = Math.min.apply(Math, _toConsumableArray(ranges.map(function (range) {
            return range.$from.pos;
          })));
          var to = Math.max.apply(Math, _toConsumableArray(ranges.map(function (range) {
            return range.$to.pos;
          })));
          var textSerializers = getTextSerializersFromSchema(schema);
          var range = {
            from: from,
            to: to
          };
          return getTextBetween(doc, range, {
            textSerializers: textSerializers
          });
        }
      }
    })];
  }
});

var blur = function blur() {
  return function (_ref25) {
    var editor = _ref25.editor,
        view = _ref25.view;
    requestAnimationFrame(function () {
      var _a;

      if (!editor.isDestroyed) {
        view.dom.blur(); // Browsers should remove the caret on blur but safari does not.
        // See: https://github.com/ueberdosis/tiptap/issues/2405

        (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
      }
    });
    return true;
  };
};

var clearContent = function clearContent() {
  var emitUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (_ref26) {
    var commands = _ref26.commands;
    return commands.setContent('', emitUpdate);
  };
};

var clearNodes = function clearNodes() {
  return function (_ref27) {
    var state = _ref27.state,
        tr = _ref27.tr,
        dispatch = _ref27.dispatch;
    var selection = tr.selection;
    var ranges = selection.ranges;

    if (!dispatch) {
      return true;
    }

    ranges.forEach(function (_ref28) {
      var $from = _ref28.$from,
          $to = _ref28.$to;
      state.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
        if (node.type.isText) {
          return;
        }

        var doc = tr.doc,
            mapping = tr.mapping;
        var $mappedFrom = doc.resolve(mapping.map(pos));
        var $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
        var nodeRange = $mappedFrom.blockRange($mappedTo);

        if (!nodeRange) {
          return;
        }

        var targetLiftDepth = liftTarget(nodeRange);

        if (node.type.isTextblock) {
          var _$mappedFrom$parent$c = $mappedFrom.parent.contentMatchAt($mappedFrom.index()),
              defaultType = _$mappedFrom$parent$c.defaultType;

          tr.setNodeMarkup(nodeRange.start, defaultType);
        }

        if (targetLiftDepth || targetLiftDepth === 0) {
          tr.lift(nodeRange, targetLiftDepth);
        }
      });
    });
    return true;
  };
};

var command = function command(fn) {
  return function (props) {
    return fn(props);
  };
};

var createParagraphNear = function createParagraphNear() {
  return function (_ref29) {
    var state = _ref29.state,
        dispatch = _ref29.dispatch;
    return createParagraphNear$1(state, dispatch);
  };
};

var cut = function cut(originRange, targetPos) {
  return function (_ref30) {
    var editor = _ref30.editor,
        tr = _ref30.tr;
    var state = editor.state;
    var contentSlice = state.doc.slice(originRange.from, originRange.to);
    tr.deleteRange(originRange.from, originRange.to);
    var newPos = tr.mapping.map(targetPos);
    tr.insert(newPos, contentSlice.content);
    tr.setSelection(new TextSelection(tr.doc.resolve(newPos - 1)));
    return true;
  };
};

var deleteCurrentNode = function deleteCurrentNode() {
  return function (_ref31) {
    var tr = _ref31.tr,
        dispatch = _ref31.dispatch;
    var selection = tr.selection;
    var currentNode = selection.$anchor.node(); // if there is content inside the current node, break out of this command

    if (currentNode.content.size > 0) {
      return false;
    }

    var $pos = tr.selection.$anchor;

    for (var depth = $pos.depth; depth > 0; depth -= 1) {
      var node = $pos.node(depth);

      if (node.type === currentNode.type) {
        if (dispatch) {
          var from = $pos.before(depth);
          var to = $pos.after(depth);
          tr.delete(from, to).scrollIntoView();
        }

        return true;
      }
    }

    return false;
  };
};

var deleteNode = function deleteNode(typeOrName) {
  return function (_ref32) {
    var tr = _ref32.tr,
        state = _ref32.state,
        dispatch = _ref32.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    var $pos = tr.selection.$anchor;

    for (var depth = $pos.depth; depth > 0; depth -= 1) {
      var node = $pos.node(depth);

      if (node.type === type) {
        if (dispatch) {
          var from = $pos.before(depth);
          var to = $pos.after(depth);
          tr.delete(from, to).scrollIntoView();
        }

        return true;
      }
    }

    return false;
  };
};

var deleteRange = function deleteRange(range) {
  return function (_ref33) {
    var tr = _ref33.tr,
        dispatch = _ref33.dispatch;
    var from = range.from,
        to = range.to;

    if (dispatch) {
      tr.delete(from, to);
    }

    return true;
  };
};

var deleteSelection = function deleteSelection() {
  return function (_ref34) {
    var state = _ref34.state,
        dispatch = _ref34.dispatch;
    return deleteSelection$1(state, dispatch);
  };
};

var enter = function enter() {
  return function (_ref35) {
    var commands = _ref35.commands;
    return commands.keyboardShortcut('Enter');
  };
};

var exitCode = function exitCode() {
  return function (_ref36) {
    var state = _ref36.state,
        dispatch = _ref36.dispatch;
    return exitCode$1(state, dispatch);
  };
};
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */


function objectIncludes(object1, object2) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    strict: true
  };
  var keys = Object.keys(object2);

  if (!keys.length) {
    return true;
  }

  return keys.every(function (key) {
    if (options.strict) {
      return object2[key] === object1[key];
    }

    if (isRegExp(object2[key])) {
      return object2[key].test(object1[key]);
    }

    return object2[key] === object1[key];
  });
}

function findMarkInSet(marks, type) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return marks.find(function (item) {
    return item.type === type && objectIncludes(item.attrs, attributes);
  });
}

function isMarkInSet(marks, type) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return !!findMarkInSet(marks, type, attributes);
}

function getMarkRange($pos, type) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!$pos || !type) {
    return;
  }

  var start = $pos.parent.childAfter($pos.parentOffset);

  if ($pos.parentOffset === start.offset && start.offset !== 0) {
    start = $pos.parent.childBefore($pos.parentOffset);
  }

  if (!start.node) {
    return;
  }

  var mark = findMarkInSet(_toConsumableArray(start.node.marks), type, attributes);

  if (!mark) {
    return;
  }

  var startIndex = start.index;
  var startPos = $pos.start() + start.offset;
  var endIndex = startIndex + 1;
  var endPos = startPos + start.node.nodeSize;
  findMarkInSet(_toConsumableArray(start.node.marks), type, attributes);

  while (startIndex > 0 && mark.isInSet($pos.parent.child(startIndex - 1).marks)) {
    startIndex -= 1;
    startPos -= $pos.parent.child(startIndex).nodeSize;
  }

  while (endIndex < $pos.parent.childCount && isMarkInSet(_toConsumableArray($pos.parent.child(endIndex).marks), type, attributes)) {
    endPos += $pos.parent.child(endIndex).nodeSize;
    endIndex += 1;
  }

  return {
    from: startPos,
    to: endPos
  };
}

function getMarkType(nameOrType, schema) {
  if (typeof nameOrType === 'string') {
    if (!schema.marks[nameOrType]) {
      throw Error("There is no mark type named '".concat(nameOrType, "'. Maybe you forgot to add the extension?"));
    }

    return schema.marks[nameOrType];
  }

  return nameOrType;
}

var extendMarkRange = function extendMarkRange(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref37) {
    var tr = _ref37.tr,
        state = _ref37.state,
        dispatch = _ref37.dispatch;
    var type = getMarkType(typeOrName, state.schema);
    var doc = tr.doc,
        selection = tr.selection;
    var $from = selection.$from,
        from = selection.from,
        to = selection.to;

    if (dispatch) {
      var range = getMarkRange($from, type, attributes);

      if (range && range.from <= from && range.to >= to) {
        var newSelection = TextSelection.create(doc, range.from, range.to);
        tr.setSelection(newSelection);
      }
    }

    return true;
  };
};

var first = function first(commands) {
  return function (props) {
    var items = typeof commands === 'function' ? commands(props) : commands;

    for (var i = 0; i < items.length; i += 1) {
      if (items[i](props)) {
        return true;
      }
    }

    return false;
  };
};

function isTextSelection(value) {
  return value instanceof TextSelection;
}

function minMax() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.min(Math.max(value, min), max);
}

function resolveFocusPosition(doc) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!position) {
    return null;
  }

  var selectionAtStart = Selection.atStart(doc);
  var selectionAtEnd = Selection.atEnd(doc);

  if (position === 'start' || position === true) {
    return selectionAtStart;
  }

  if (position === 'end') {
    return selectionAtEnd;
  }

  var minPos = selectionAtStart.from;
  var maxPos = selectionAtEnd.to;

  if (position === 'all') {
    return TextSelection.create(doc, minMax(0, minPos, maxPos), minMax(doc.content.size, minPos, maxPos));
  }

  return TextSelection.create(doc, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}

function isiOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) // iPad on iOS 13 detection
  || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}

var focus = function focus() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref38) {
    var editor = _ref38.editor,
        view = _ref38.view,
        tr = _ref38.tr,
        dispatch = _ref38.dispatch;
    options = _objectSpread({
      scrollIntoView: true
    }, options);

    var delayedFocus = function delayedFocus() {
      // focus within `requestAnimationFrame` breaks focus on iOS
      // so we have to call this
      if (isiOS()) {
        view.dom.focus();
      } // For React we have to focus asynchronously. Otherwise wild things happen.
      // see: https://github.com/ueberdosis/tiptap/issues/1520


      requestAnimationFrame(function () {
        if (!editor.isDestroyed) {
          view.focus();

          if (options === null || options === void 0 ? void 0 : options.scrollIntoView) {
            editor.commands.scrollIntoView();
          }
        }
      });
    };

    if (view.hasFocus() && position === null || position === false) {
      return true;
    } // we don’t try to resolve a NodeSelection or CellSelection


    if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
      delayedFocus();
      return true;
    } // pass through tr.doc instead of editor.state.doc
    // since transactions could change the editors state before this command has been run


    var selection = resolveFocusPosition(tr.doc, position) || editor.state.selection;
    var isSameSelection = editor.state.selection.eq(selection);

    if (dispatch) {
      if (!isSameSelection) {
        tr.setSelection(selection);
      } // `tr.setSelection` resets the stored marks
      // so we’ll restore them if the selection is the same as before


      if (isSameSelection && tr.storedMarks) {
        tr.setStoredMarks(tr.storedMarks);
      }

      delayedFocus();
    }

    return true;
  };
};

var forEach = function forEach(items, fn) {
  return function (props) {
    return items.every(function (item, index) {
      return fn(item, _objectSpread(_objectSpread({}, props), {}, {
        index: index
      }));
    });
  };
};

var insertContent = function insertContent(value, options) {
  return function (_ref39) {
    var tr = _ref39.tr,
        commands = _ref39.commands;
    return commands.insertContentAt({
      from: tr.selection.from,
      to: tr.selection.to
    }, value, options);
  };
};

function elementFromString(value) {
  // add a wrapper to preserve leading and trailing whitespace
  var wrappedValue = "<body>".concat(value, "</body>");
  return new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
}

function createNodeFromContent(content, schema, options) {
  options = _objectSpread({
    slice: true,
    parseOptions: {}
  }, options);

  if (_typeof(content) === 'object' && content !== null) {
    try {
      if (Array.isArray(content) && content.length > 0) {
        return Fragment.fromArray(content.map(function (item) {
          return schema.nodeFromJSON(item);
        }));
      }

      return schema.nodeFromJSON(content);
    } catch (error) {
      console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
      return createNodeFromContent('', schema, options);
    }
  }

  if (typeof content === 'string') {
    var parser = DOMParser.fromSchema(schema);
    return options.slice ? parser.parseSlice(elementFromString(content), options.parseOptions).content : parser.parse(elementFromString(content), options.parseOptions);
  }

  return createNodeFromContent('', schema, options);
} // source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466


function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;

  if (last < startLen) {
    return;
  }

  var step = tr.steps[last];

  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) {
    return;
  }

  var map = tr.mapping.maps[last];
  var end = 0;
  map.forEach(function (_from, _to, _newFrom, newTo) {
    if (end === 0) {
      end = newTo;
    }
  });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var isFragment = function isFragment(nodeOrFragment) {
  return nodeOrFragment.toString().startsWith('<');
};

var insertContentAt = function insertContentAt(position, value, options) {
  return function (_ref40) {
    var tr = _ref40.tr,
        dispatch = _ref40.dispatch,
        editor = _ref40.editor;

    if (dispatch) {
      options = _objectSpread({
        parseOptions: {},
        updateSelection: true
      }, options);
      var content = createNodeFromContent(value, editor.schema, {
        parseOptions: _objectSpread({
          preserveWhitespace: 'full'
        }, options.parseOptions)
      }); // don’t dispatch an empty fragment because this can lead to strange errors

      if (content.toString() === '<>') {
        return true;
      }

      var _ref41 = typeof position === 'number' ? {
        from: position,
        to: position
      } : {
        from: position.from,
        to: position.to
      },
          from = _ref41.from,
          to = _ref41.to;

      var isOnlyTextContent = true;
      var isOnlyBlockContent = true;
      var nodes = isFragment(content) ? content : [content];
      nodes.forEach(function (node) {
        // check if added node is valid
        node.check();
        isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
        isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
      }); // check if we can replace the wrapping node by
      // the newly inserted content
      // example:
      // replace an empty paragraph by an inserted image
      // instead of inserting the image below the paragraph

      if (from === to && isOnlyBlockContent) {
        var _tr$doc$resolve = tr.doc.resolve(from),
            parent = _tr$doc$resolve.parent;

        var isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;

        if (isEmptyTextBlock) {
          from -= 1;
          to += 1;
        }
      } // if there is only plain text we have to use `insertText`
      // because this will keep the current marks


      if (isOnlyTextContent) {
        // if value is string, we can use it directly
        // otherwise if it is an array, we have to join it
        if (Array.isArray(value)) {
          tr.insertText(value.map(function (v) {
            return v.text || '';
          }).join(''), from, to);
        } else if (_typeof(value) === 'object' && !!value && !!value.text) {
          tr.insertText(value.text, from, to);
        } else {
          tr.insertText(value, from, to);
        }
      } else {
        tr.replaceWith(from, to, content);
      } // set cursor at end of inserted content


      if (options.updateSelection) {
        selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
      }
    }

    return true;
  };
};

var joinUp = function joinUp() {
  return function (_ref42) {
    var state = _ref42.state,
        dispatch = _ref42.dispatch;
    return joinUp$1(state, dispatch);
  };
};

var joinDown = function joinDown() {
  return function (_ref43) {
    var state = _ref43.state,
        dispatch = _ref43.dispatch;
    return joinDown$1(state, dispatch);
  };
};

var joinBackward = function joinBackward() {
  return function (_ref44) {
    var state = _ref44.state,
        dispatch = _ref44.dispatch;
    return joinBackward$1(state, dispatch);
  };
};

var joinForward = function joinForward() {
  return function (_ref45) {
    var state = _ref45.state,
        dispatch = _ref45.dispatch;
    return joinForward$1(state, dispatch);
  };
};

var joinItemBackward = function joinItemBackward() {
  return function (_ref46) {
    var tr = _ref46.tr,
        state = _ref46.state,
        dispatch = _ref46.dispatch;

    try {
      var point = joinPoint(state.doc, state.selection.$from.pos, -1);

      if (point === null || point === undefined) {
        return false;
      }

      tr.join(point, 2);

      if (dispatch) {
        dispatch(tr);
      }

      return true;
    } catch (_unused) {
      return false;
    }
  };
};

var joinItemForward = function joinItemForward() {
  return function (_ref47) {
    var state = _ref47.state,
        dispatch = _ref47.dispatch,
        tr = _ref47.tr;

    try {
      var point = joinPoint(state.doc, state.selection.$from.pos, +1);

      if (point === null || point === undefined) {
        return false;
      }

      tr.join(point, 2);

      if (dispatch) {
        dispatch(tr);
      }

      return true;
    } catch (e) {
      return false;
    }
  };
};

function isMacOS() {
  return typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
}

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/);
  var result = parts[parts.length - 1];

  if (result === 'Space') {
    result = ' ';
  }

  var alt;
  var ctrl;
  var shift;
  var meta;

  for (var i = 0; i < parts.length - 1; i += 1) {
    var mod = parts[i];

    if (/^(cmd|meta|m)$/i.test(mod)) {
      meta = true;
    } else if (/^a(lt)?$/i.test(mod)) {
      alt = true;
    } else if (/^(c|ctrl|control)$/i.test(mod)) {
      ctrl = true;
    } else if (/^s(hift)?$/i.test(mod)) {
      shift = true;
    } else if (/^mod$/i.test(mod)) {
      if (isiOS() || isMacOS()) {
        meta = true;
      } else {
        ctrl = true;
      }
    } else {
      throw new Error("Unrecognized modifier name: ".concat(mod));
    }
  }

  if (alt) {
    result = "Alt-".concat(result);
  }

  if (ctrl) {
    result = "Ctrl-".concat(result);
  }

  if (meta) {
    result = "Meta-".concat(result);
  }

  if (shift) {
    result = "Shift-".concat(result);
  }

  return result;
}

var keyboardShortcut = function keyboardShortcut(name) {
  return function (_ref48) {
    var editor = _ref48.editor,
        view = _ref48.view,
        tr = _ref48.tr,
        dispatch = _ref48.dispatch;
    var keys = normalizeKeyName(name).split(/-(?!$)/);
    var key = keys.find(function (item) {
      return !['Alt', 'Ctrl', 'Meta', 'Shift'].includes(item);
    });
    var event = new KeyboardEvent('keydown', {
      key: key === 'Space' ? ' ' : key,
      altKey: keys.includes('Alt'),
      ctrlKey: keys.includes('Ctrl'),
      metaKey: keys.includes('Meta'),
      shiftKey: keys.includes('Shift'),
      bubbles: true,
      cancelable: true
    });
    var capturedTransaction = editor.captureTransaction(function () {
      view.someProp('handleKeyDown', function (f) {
        return f(view, event);
      });
    });
    capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach(function (step) {
      var newStep = step.map(tr.mapping);

      if (newStep && dispatch) {
        tr.maybeStep(newStep);
      }
    });
    return true;
  };
};

function isNodeActive(state, typeOrName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _state$selection = state.selection,
      from = _state$selection.from,
      to = _state$selection.to,
      empty = _state$selection.empty;
  var type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
  var nodeRanges = [];
  state.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      return;
    }

    var relativeFrom = Math.max(from, pos);
    var relativeTo = Math.min(to, pos + node.nodeSize);
    nodeRanges.push({
      node: node,
      from: relativeFrom,
      to: relativeTo
    });
  });
  var selectionRange = to - from;
  var matchedNodeRanges = nodeRanges.filter(function (nodeRange) {
    if (!type) {
      return true;
    }

    return type.name === nodeRange.node.type.name;
  }).filter(function (nodeRange) {
    return objectIncludes(nodeRange.node.attrs, attributes, {
      strict: false
    });
  });

  if (empty) {
    return !!matchedNodeRanges.length;
  }

  var range = matchedNodeRanges.reduce(function (sum, nodeRange) {
    return sum + nodeRange.to - nodeRange.from;
  }, 0);
  return range >= selectionRange;
}

var lift = function lift(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref49) {
    var state = _ref49.state,
        dispatch = _ref49.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    var isActive = isNodeActive(state, type, attributes);

    if (!isActive) {
      return false;
    }

    return lift$1(state, dispatch);
  };
};

var liftEmptyBlock = function liftEmptyBlock() {
  return function (_ref50) {
    var state = _ref50.state,
        dispatch = _ref50.dispatch;
    return liftEmptyBlock$1(state, dispatch);
  };
};

var liftListItem = function liftListItem(typeOrName) {
  return function (_ref51) {
    var state = _ref51.state,
        dispatch = _ref51.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return liftListItem$1(type)(state, dispatch);
  };
};

var newlineInCode = function newlineInCode() {
  return function (_ref52) {
    var state = _ref52.state,
        dispatch = _ref52.dispatch;
    return newlineInCode$1(state, dispatch);
  };
};

function getSchemaTypeNameByName(name, schema) {
  if (schema.nodes[name]) {
    return 'node';
  }

  if (schema.marks[name]) {
    return 'mark';
  }

  return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */


function deleteProps(obj, propOrProps) {
  var props = typeof propOrProps === 'string' ? [propOrProps] : propOrProps;
  return Object.keys(obj).reduce(function (newObj, prop) {
    if (!props.includes(prop)) {
      newObj[prop] = obj[prop];
    }

    return newObj;
  }, {});
}

var resetAttributes = function resetAttributes(typeOrName, attributes) {
  return function (_ref53) {
    var tr = _ref53.tr,
        state = _ref53.state,
        dispatch = _ref53.dispatch;
    var nodeType = null;
    var markType = null;
    var schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);

    if (!schemaType) {
      return false;
    }

    if (schemaType === 'node') {
      nodeType = getNodeType(typeOrName, state.schema);
    }

    if (schemaType === 'mark') {
      markType = getMarkType(typeOrName, state.schema);
    }

    if (dispatch) {
      tr.selection.ranges.forEach(function (range) {
        state.doc.nodesBetween(range.$from.pos, range.$to.pos, function (node, pos) {
          if (nodeType && nodeType === node.type) {
            tr.setNodeMarkup(pos, undefined, deleteProps(node.attrs, attributes));
          }

          if (markType && node.marks.length) {
            node.marks.forEach(function (mark) {
              if (markType === mark.type) {
                tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
              }
            });
          }
        });
      });
    }

    return true;
  };
};

var scrollIntoView = function scrollIntoView() {
  return function (_ref54) {
    var tr = _ref54.tr,
        dispatch = _ref54.dispatch;

    if (dispatch) {
      tr.scrollIntoView();
    }

    return true;
  };
};

var selectAll = function selectAll() {
  return function (_ref55) {
    var tr = _ref55.tr,
        commands = _ref55.commands;
    return commands.setTextSelection({
      from: 0,
      to: tr.doc.content.size
    });
  };
};

var selectNodeBackward = function selectNodeBackward() {
  return function (_ref56) {
    var state = _ref56.state,
        dispatch = _ref56.dispatch;
    return selectNodeBackward$1(state, dispatch);
  };
};

var selectNodeForward = function selectNodeForward() {
  return function (_ref57) {
    var state = _ref57.state,
        dispatch = _ref57.dispatch;
    return selectNodeForward$1(state, dispatch);
  };
};

var selectParentNode = function selectParentNode() {
  return function (_ref58) {
    var state = _ref58.state,
        dispatch = _ref58.dispatch;
    return selectParentNode$1(state, dispatch);
  };
}; // @ts-ignore


var selectTextblockEnd = function selectTextblockEnd() {
  return function (_ref59) {
    var state = _ref59.state,
        dispatch = _ref59.dispatch;
    return selectTextblockEnd$1(state, dispatch);
  };
}; // @ts-ignore


var selectTextblockStart = function selectTextblockStart() {
  return function (_ref60) {
    var state = _ref60.state,
        dispatch = _ref60.dispatch;
    return selectTextblockStart$1(state, dispatch);
  };
};

function createDocument(content, schema) {
  var parseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return createNodeFromContent(content, schema, {
    slice: false,
    parseOptions: parseOptions
  });
}

var setContent = function setContent(content) {
  var emitUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var parseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (_ref61) {
    var tr = _ref61.tr,
        editor = _ref61.editor,
        dispatch = _ref61.dispatch;
    var doc = tr.doc;
    var document = createDocument(content, editor.schema, parseOptions);

    if (dispatch) {
      tr.replaceWith(0, doc.content.size, document).setMeta('preventUpdate', !emitUpdate);
    }

    return true;
  };
};

function getMarkAttributes(state, typeOrName) {
  var type = getMarkType(typeOrName, state.schema);
  var _state$selection2 = state.selection,
      from = _state$selection2.from,
      to = _state$selection2.to,
      empty = _state$selection2.empty;
  var marks = [];

  if (empty) {
    if (state.storedMarks) {
      marks.push.apply(marks, _toConsumableArray(state.storedMarks));
    }

    marks.push.apply(marks, _toConsumableArray(state.selection.$head.marks()));
  } else {
    state.doc.nodesBetween(from, to, function (node) {
      marks.push.apply(marks, _toConsumableArray(node.marks));
    });
  }

  var mark = marks.find(function (markItem) {
    return markItem.type.name === type.name;
  });

  if (!mark) {
    return {};
  }

  return _objectSpread({}, mark.attrs);
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 */


function combineTransactionSteps(oldDoc, transactions) {
  var transform = new Transform(oldDoc);
  transactions.forEach(function (transaction) {
    transaction.steps.forEach(function (step) {
      transform.step(step);
    });
  });
  return transform;
}

function defaultBlockAt(match) {
  for (var i = 0; i < match.edgeCount; i += 1) {
    var _match$edge = match.edge(i),
        type = _match$edge.type;

    if (type.isTextblock && !type.hasRequiredAttrs()) {
      return type;
    }
  }

  return null;
}

function findChildren(node, predicate) {
  var nodesWithPos = [];
  node.descendants(function (child, pos) {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos: pos
      });
    }
  });
  return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 */


function findChildrenInRange(node, range, predicate) {
  var nodesWithPos = []; // if (range.from === range.to) {
  //   const nodeAt = node.nodeAt(range.from)
  //   if (nodeAt) {
  //     nodesWithPos.push({
  //       node: nodeAt,
  //       pos: range.from,
  //     })
  //   }
  // }

  node.nodesBetween(range.from, range.to, function (child, pos) {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos: pos
      });
    }
  });
  return nodesWithPos;
}

function findParentNodeClosestToPos($pos, predicate) {
  for (var i = $pos.depth; i > 0; i -= 1) {
    var node = $pos.node(i);

    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node: node
      };
    }
  }
}

function findParentNode(predicate) {
  return function (selection) {
    return findParentNodeClosestToPos(selection.$from, predicate);
  };
}

function getHTMLFromFragment(fragment, schema) {
  var documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
  var temporaryDocument = document.implementation.createHTMLDocument();
  var container = temporaryDocument.createElement('div');
  container.appendChild(documentFragment);
  return container.innerHTML;
}

function getSchema(extensions, editor) {
  var resolvedExtensions = ExtensionManager.resolve(extensions);
  return getSchemaByResolvedExtensions(resolvedExtensions, editor);
}

function generateHTML(doc, extensions) {
  var schema = getSchema(extensions);
  var contentNode = Node$1.fromJSON(schema, doc);
  return getHTMLFromFragment(contentNode.content, schema);
}

function generateJSON(html, extensions) {
  var schema = getSchema(extensions);
  var dom = elementFromString(html);
  return DOMParser.fromSchema(schema).parse(dom).toJSON();
}

function _getText(node, options) {
  var range = {
    from: 0,
    to: node.content.size
  };
  return getTextBetween(node, range, options);
}

function generateText(doc, extensions, options) {
  var _ref62 = options || {},
      _ref62$blockSeparator = _ref62.blockSeparator,
      blockSeparator = _ref62$blockSeparator === void 0 ? '\n\n' : _ref62$blockSeparator,
      _ref62$textSerializer = _ref62.textSerializers,
      textSerializers = _ref62$textSerializer === void 0 ? {} : _ref62$textSerializer;

  var schema = getSchema(extensions);
  var contentNode = Node$1.fromJSON(schema, doc);
  return _getText(contentNode, {
    blockSeparator: blockSeparator,
    textSerializers: _objectSpread(_objectSpread({}, getTextSerializersFromSchema(schema)), textSerializers)
  });
}

function getNodeAttributes(state, typeOrName) {
  var type = getNodeType(typeOrName, state.schema);
  var _state$selection3 = state.selection,
      from = _state$selection3.from,
      to = _state$selection3.to;
  var nodes = [];
  state.doc.nodesBetween(from, to, function (node) {
    nodes.push(node);
  });
  var node = nodes.reverse().find(function (nodeItem) {
    return nodeItem.type.name === type.name;
  });

  if (!node) {
    return {};
  }

  return _objectSpread({}, node.attrs);
}

function _getAttributes(state, typeOrName) {
  var schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);

  if (schemaType === 'node') {
    return getNodeAttributes(state, typeOrName);
  }

  if (schemaType === 'mark') {
    return getMarkAttributes(state, typeOrName);
  }

  return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */


function removeDuplicates(array) {
  var by = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : JSON.stringify;
  var seen = {};
  return array.filter(function (item) {
    var key = by(item);
    return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
  });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */


function simplifyChangedRanges(changes) {
  var uniqueChanges = removeDuplicates(changes);
  return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter(function (change, index) {
    var rest = uniqueChanges.filter(function (_, i) {
      return i !== index;
    });
    return !rest.some(function (otherChange) {
      return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
    });
  });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */


function getChangedRanges(transform) {
  var mapping = transform.mapping,
      steps = transform.steps;
  var changes = [];
  mapping.maps.forEach(function (stepMap, index) {
    var ranges = []; // This accounts for step changes where no range was actually altered
    // e.g. when setting a mark, node attribute, etc.
    // @ts-ignore

    if (!stepMap.ranges.length) {
      var _steps$index = steps[index],
          from = _steps$index.from,
          to = _steps$index.to;

      if (from === undefined || to === undefined) {
        return;
      }

      ranges.push({
        from: from,
        to: to
      });
    } else {
      stepMap.forEach(function (from, to) {
        ranges.push({
          from: from,
          to: to
        });
      });
    }

    ranges.forEach(function (_ref63) {
      var from = _ref63.from,
          to = _ref63.to;
      var newStart = mapping.slice(index).map(from, -1);
      var newEnd = mapping.slice(index).map(to);
      var oldStart = mapping.invert().map(newStart, -1);
      var oldEnd = mapping.invert().map(newEnd);
      changes.push({
        oldRange: {
          from: oldStart,
          to: oldEnd
        },
        newRange: {
          from: newStart,
          to: newEnd
        }
      });
    });
  });
  return simplifyChangedRanges(changes);
}

function getDebugJSON(node) {
  var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isTopNode = node.type === node.type.schema.topNodeType;
  var increment = isTopNode ? 0 : 1;
  var from = startOffset;
  var to = from + node.nodeSize;
  var marks = node.marks.map(function (mark) {
    var output = {
      type: mark.type.name
    };

    if (Object.keys(mark.attrs).length) {
      output.attrs = _objectSpread({}, mark.attrs);
    }

    return output;
  });

  var attrs = _objectSpread({}, node.attrs);

  var output = {
    type: node.type.name,
    from: from,
    to: to
  };

  if (Object.keys(attrs).length) {
    output.attrs = attrs;
  }

  if (marks.length) {
    output.marks = marks;
  }

  if (node.content.childCount) {
    output.content = [];
    node.forEach(function (child, offset) {
      var _a;

      (_a = output.content) === null || _a === void 0 ? void 0 : _a.push(getDebugJSON(child, startOffset + offset + increment));
    });
  }

  if (node.text) {
    output.text = node.text;
  }

  return output;
}

function getMarksBetween(from, to, doc) {
  var marks = []; // get all inclusive marks on empty selection

  if (from === to) {
    doc.resolve(from).marks().forEach(function (mark) {
      var $pos = doc.resolve(from - 1);
      var range = getMarkRange($pos, mark.type);

      if (!range) {
        return;
      }

      marks.push(_objectSpread({
        mark: mark
      }, range));
    });
  } else {
    doc.nodesBetween(from, to, function (node, pos) {
      marks.push.apply(marks, _toConsumableArray(node.marks.map(function (mark) {
        return {
          from: pos,
          to: pos + node.nodeSize,
          mark: mark
        };
      })));
    });
  }

  return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */


var getNodeAtPosition = function getNodeAtPosition(state, typeOrName, pos) {
  var maxDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
  var $pos = state.doc.resolve(pos);
  var currentDepth = maxDepth;
  var node = null;

  while (currentDepth > 0 && node === null) {
    var currentNode = $pos.node(currentDepth);

    if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) {
      node = currentNode;
    } else {
      currentDepth -= 1;
    }
  }

  return [node, currentDepth];
};

function getSplittedAttributes(extensionAttributes, typeName, attributes) {
  return Object.fromEntries(Object.entries(attributes).filter(function (_ref64) {
    var _ref65 = _slicedToArray(_ref64, 1),
        name = _ref65[0];

    var extensionAttribute = extensionAttributes.find(function (item) {
      return item.type === typeName && item.name === name;
    });

    if (!extensionAttribute) {
      return false;
    }

    return extensionAttribute.attribute.keepOnSplit;
  }));
}

function isMarkActive(state, typeOrName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _state$selection4 = state.selection,
      empty = _state$selection4.empty,
      ranges = _state$selection4.ranges;
  var type = typeOrName ? getMarkType(typeOrName, state.schema) : null;

  if (empty) {
    return !!(state.storedMarks || state.selection.$from.marks()).filter(function (mark) {
      if (!type) {
        return true;
      }

      return type.name === mark.type.name;
    }).find(function (mark) {
      return objectIncludes(mark.attrs, attributes, {
        strict: false
      });
    });
  }

  var selectionRange = 0;
  var markRanges = [];
  ranges.forEach(function (_ref66) {
    var $from = _ref66.$from,
        $to = _ref66.$to;
    var from = $from.pos;
    var to = $to.pos;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (!node.isText && !node.marks.length) {
        return;
      }

      var relativeFrom = Math.max(from, pos);
      var relativeTo = Math.min(to, pos + node.nodeSize);
      var range = relativeTo - relativeFrom;
      selectionRange += range;
      markRanges.push.apply(markRanges, _toConsumableArray(node.marks.map(function (mark) {
        return {
          mark: mark,
          from: relativeFrom,
          to: relativeTo
        };
      })));
    });
  });

  if (selectionRange === 0) {
    return false;
  } // calculate range of matched mark


  var matchedRange = markRanges.filter(function (markRange) {
    if (!type) {
      return true;
    }

    return type.name === markRange.mark.type.name;
  }).filter(function (markRange) {
    return objectIncludes(markRange.mark.attrs, attributes, {
      strict: false
    });
  }).reduce(function (sum, markRange) {
    return sum + markRange.to - markRange.from;
  }, 0); // calculate range of marks that excludes the searched mark
  // for example `code` doesn’t allow any other marks

  var excludedRange = markRanges.filter(function (markRange) {
    if (!type) {
      return true;
    }

    return markRange.mark.type !== type && markRange.mark.type.excludes(type);
  }).reduce(function (sum, markRange) {
    return sum + markRange.to - markRange.from;
  }, 0); // we only include the result of `excludedRange`
  // if there is a match at all

  var range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
  return range >= selectionRange;
}

function _isActive(state, name) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!name) {
    return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
  }

  var schemaType = getSchemaTypeNameByName(name, state.schema);

  if (schemaType === 'node') {
    return isNodeActive(state, name, attributes);
  }

  if (schemaType === 'mark') {
    return isMarkActive(state, name, attributes);
  }

  return false;
}

var isAtEndOfNode = function isAtEndOfNode(state, nodeType) {
  var _state$selection5 = state.selection,
      $from = _state$selection5.$from,
      $to = _state$selection5.$to,
      $anchor = _state$selection5.$anchor;

  if (nodeType) {
    var parentNode = findParentNode(function (node) {
      return node.type.name === nodeType;
    })(state.selection);

    if (!parentNode) {
      return false;
    }

    var $parentPos = state.doc.resolve(parentNode.pos + 1);

    if ($anchor.pos + 1 === $parentPos.end()) {
      return true;
    }

    return false;
  }

  if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) {
    return false;
  }

  return true;
};

var isAtStartOfNode = function isAtStartOfNode(state) {
  var _state$selection6 = state.selection,
      $from = _state$selection6.$from,
      $to = _state$selection6.$to;

  if ($from.parentOffset > 0 || $from.pos !== $to.pos) {
    return false;
  }

  return true;
};

function isList(name, extensions) {
  var _splitExtensions4 = splitExtensions(extensions),
      nodeExtensions = _splitExtensions4.nodeExtensions;

  var extension = nodeExtensions.find(function (item) {
    return item.name === name;
  });

  if (!extension) {
    return false;
  }

  var context = {
    name: extension.name,
    options: extension.options,
    storage: extension.storage
  };
  var group = callOrReturn(getExtensionField(extension, 'group', context));

  if (typeof group !== 'string') {
    return false;
  }

  return group.split(' ').includes('list');
}

function isNodeEmpty(node) {
  var _a;

  var defaultContent = (_a = node.type.createAndFill()) === null || _a === void 0 ? void 0 : _a.toJSON();
  var content = node.toJSON();
  return JSON.stringify(defaultContent) === JSON.stringify(content);
}

function isNodeSelection(value) {
  return value instanceof NodeSelection;
}

function posToDOMRect(view, from, to) {
  var minPos = 0;
  var maxPos = view.state.doc.content.size;
  var resolvedFrom = minMax(from, minPos, maxPos);
  var resolvedEnd = minMax(to, minPos, maxPos);
  var start = view.coordsAtPos(resolvedFrom);
  var end = view.coordsAtPos(resolvedEnd, -1);
  var top = Math.min(start.top, end.top);
  var bottom = Math.max(start.bottom, end.bottom);
  var left = Math.min(start.left, end.left);
  var right = Math.max(start.right, end.right);
  var width = right - left;
  var height = bottom - top;
  var x = left;
  var y = top;
  var data = {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height,
    x: x,
    y: y
  };
  return _objectSpread(_objectSpread({}, data), {}, {
    toJSON: function toJSON() {
      return data;
    }
  });
}

function canSetMark(state, tr, newMarkType) {
  var _a;

  var selection = tr.selection;
  var cursor = null;

  if (isTextSelection(selection)) {
    cursor = selection.$cursor;
  }

  if (cursor) {
    var currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks(); // There can be no current marks that exclude the new mark

    return !!newMarkType.isInSet(currentMarks) || !currentMarks.some(function (mark) {
      return mark.type.excludes(newMarkType);
    });
  }

  var ranges = selection.ranges;
  return ranges.some(function (_ref67) {
    var $from = _ref67.$from,
        $to = _ref67.$to;
    var someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
    state.doc.nodesBetween($from.pos, $to.pos, function (node, _pos, parent) {
      // If we already found a mark that we can enable, return false to bypass the remaining search
      if (someNodeSupportsMark) {
        return false;
      }

      if (node.isInline) {
        var parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
        var currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some(function (otherMark) {
          return otherMark.type.excludes(newMarkType);
        });
        someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
      }

      return !someNodeSupportsMark;
    });
    return someNodeSupportsMark;
  });
}

var setMark = function setMark(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref68) {
    var tr = _ref68.tr,
        state = _ref68.state,
        dispatch = _ref68.dispatch;
    var selection = tr.selection;
    var empty = selection.empty,
        ranges = selection.ranges;
    var type = getMarkType(typeOrName, state.schema);

    if (dispatch) {
      if (empty) {
        var oldAttributes = getMarkAttributes(state, type);
        tr.addStoredMark(type.create(_objectSpread(_objectSpread({}, oldAttributes), attributes)));
      } else {
        ranges.forEach(function (range) {
          var from = range.$from.pos;
          var to = range.$to.pos;
          state.doc.nodesBetween(from, to, function (node, pos) {
            var trimmedFrom = Math.max(pos, from);
            var trimmedTo = Math.min(pos + node.nodeSize, to);
            var someHasMark = node.marks.find(function (mark) {
              return mark.type === type;
            }); // if there is already a mark of this type
            // we know that we have to merge its attributes
            // otherwise we add a fresh new mark

            if (someHasMark) {
              node.marks.forEach(function (mark) {
                if (type === mark.type) {
                  tr.addMark(trimmedFrom, trimmedTo, type.create(_objectSpread(_objectSpread({}, mark.attrs), attributes)));
                }
              });
            } else {
              tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
            }
          });
        });
      }
    }

    return canSetMark(state, tr, type);
  };
};

var setMeta = function setMeta(key, value) {
  return function (_ref69) {
    var tr = _ref69.tr;
    tr.setMeta(key, value);
    return true;
  };
};

var setNode = function setNode(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref70) {
    var state = _ref70.state,
        dispatch = _ref70.dispatch,
        chain = _ref70.chain;
    var type = getNodeType(typeOrName, state.schema); // TODO: use a fallback like insertContent?

    if (!type.isTextblock) {
      console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
      return false;
    }

    return chain() // try to convert node to default node if needed
    .command(function (_ref71) {
      var commands = _ref71.commands;
      var canSetBlock = setBlockType(type, attributes)(state);

      if (canSetBlock) {
        return true;
      }

      return commands.clearNodes();
    }).command(function (_ref72) {
      var updatedState = _ref72.state;
      return setBlockType(type, attributes)(updatedState, dispatch);
    }).run();
  };
};

var setNodeSelection = function setNodeSelection(position) {
  return function (_ref73) {
    var tr = _ref73.tr,
        dispatch = _ref73.dispatch;

    if (dispatch) {
      var doc = tr.doc;
      var from = minMax(position, 0, doc.content.size);
      var selection = NodeSelection.create(doc, from);
      tr.setSelection(selection);
    }

    return true;
  };
};

var setTextSelection = function setTextSelection(position) {
  return function (_ref74) {
    var tr = _ref74.tr,
        dispatch = _ref74.dispatch;

    if (dispatch) {
      var doc = tr.doc;

      var _ref75 = typeof position === 'number' ? {
        from: position,
        to: position
      } : position,
          from = _ref75.from,
          to = _ref75.to;

      var minPos = TextSelection.atStart(doc).from;
      var maxPos = TextSelection.atEnd(doc).to;
      var resolvedFrom = minMax(from, minPos, maxPos);
      var resolvedEnd = minMax(to, minPos, maxPos);
      var selection = TextSelection.create(doc, resolvedFrom, resolvedEnd);
      tr.setSelection(selection);
    }

    return true;
  };
};

var sinkListItem = function sinkListItem(typeOrName) {
  return function (_ref76) {
    var state = _ref76.state,
        dispatch = _ref76.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return sinkListItem$1(type)(state, dispatch);
  };
};

function ensureMarks(state, splittableMarks) {
  var marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();

  if (marks) {
    var filteredMarks = marks.filter(function (mark) {
      return splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name);
    });
    state.tr.ensureMarks(filteredMarks);
  }
}

var splitBlock = function splitBlock() {
  var _ref77 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref77$keepMarks = _ref77.keepMarks,
      keepMarks = _ref77$keepMarks === void 0 ? true : _ref77$keepMarks;

  return function (_ref78) {
    var tr = _ref78.tr,
        state = _ref78.state,
        dispatch = _ref78.dispatch,
        editor = _ref78.editor;
    var selection = tr.selection,
        doc = tr.doc;
    var $from = selection.$from,
        $to = selection.$to;
    var extensionAttributes = editor.extensionManager.attributes;
    var newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);

    if (selection instanceof NodeSelection && selection.node.isBlock) {
      if (!$from.parentOffset || !canSplit(doc, $from.pos)) {
        return false;
      }

      if (dispatch) {
        if (keepMarks) {
          ensureMarks(state, editor.extensionManager.splittableMarks);
        }

        tr.split($from.pos).scrollIntoView();
      }

      return true;
    }

    if (!$from.parent.isBlock) {
      return false;
    }

    if (dispatch) {
      var atEnd = $to.parentOffset === $to.parent.content.size;

      if (selection instanceof TextSelection) {
        tr.deleteSelection();
      }

      var deflt = $from.depth === 0 ? undefined : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
      var types = atEnd && deflt ? [{
        type: deflt,
        attrs: newAttributes
      }] : undefined;
      var can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);

      if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{
        type: deflt
      }] : undefined)) {
        can = true;
        types = deflt ? [{
          type: deflt,
          attrs: newAttributes
        }] : undefined;
      }

      if (can) {
        tr.split(tr.mapping.map($from.pos), 1, types);

        if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
          var _first = tr.mapping.map($from.before());

          var $first = tr.doc.resolve(_first);

          if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
            tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
          }
        }
      }

      if (keepMarks) {
        ensureMarks(state, editor.extensionManager.splittableMarks);
      }

      tr.scrollIntoView();
    }

    return true;
  };
};

var splitListItem = function splitListItem(typeOrName) {
  return function (_ref79) {
    var tr = _ref79.tr,
        state = _ref79.state,
        dispatch = _ref79.dispatch,
        editor = _ref79.editor;

    var _a;

    var type = getNodeType(typeOrName, state.schema);
    var _state$selection7 = state.selection,
        $from = _state$selection7.$from,
        $to = _state$selection7.$to; // @ts-ignore
    // eslint-disable-next-line

    var node = state.selection.node;

    if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) {
      return false;
    }

    var grandParent = $from.node(-1);

    if (grandParent.type !== type) {
      return false;
    }

    var extensionAttributes = editor.extensionManager.attributes;

    if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) {
        return false;
      }

      if (dispatch) {
        var wrap = Fragment.empty; // eslint-disable-next-line

        var depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3; // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor

        for (var d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
          wrap = Fragment.from($from.node(d).copy(wrap));
        } // eslint-disable-next-line


        var depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3; // Add a second list item with an empty default start node

        var _newNextTypeAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);

        var _nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(_newNextTypeAttributes)) || undefined;

        wrap = wrap.append(Fragment.from(type.createAndFill(null, _nextType) || undefined));
        var start = $from.before($from.depth - (depthBefore - 1));
        tr.replace(start, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
        var sel = -1;
        tr.doc.nodesBetween(start, tr.doc.content.size, function (n, pos) {
          if (sel > -1) {
            return false;
          }

          if (n.isTextblock && n.content.size === 0) {
            sel = pos + 1;
          }
        });

        if (sel > -1) {
          tr.setSelection(TextSelection.near(tr.doc.resolve(sel)));
        }

        tr.scrollIntoView();
      }

      return true;
    }

    var nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    var newTypeAttributes = getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs);
    var newNextTypeAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
    tr.delete($from.pos, $to.pos);
    var types = nextType ? [{
      type: type,
      attrs: newTypeAttributes
    }, {
      type: nextType,
      attrs: newNextTypeAttributes
    }] : [{
      type: type,
      attrs: newTypeAttributes
    }];

    if (!canSplit(tr.doc, $from.pos, 2)) {
      return false;
    }

    if (dispatch) {
      var selection = state.selection,
          storedMarks = state.storedMarks;
      var splittableMarks = editor.extensionManager.splittableMarks;
      var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
      tr.split($from.pos, 2, types).scrollIntoView();

      if (!marks || !dispatch) {
        return true;
      }

      var filteredMarks = marks.filter(function (mark) {
        return splittableMarks.includes(mark.type.name);
      });
      tr.ensureMarks(filteredMarks);
    }

    return true;
  };
};

var joinListBackwards = function joinListBackwards(tr, listType) {
  var list = findParentNode(function (node) {
    return node.type === listType;
  })(tr.selection);

  if (!list) {
    return true;
  }

  var before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);

  if (before === undefined) {
    return true;
  }

  var nodeBefore = tr.doc.nodeAt(before);
  var canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && canJoin(tr.doc, list.pos);

  if (!canJoinBackwards) {
    return true;
  }

  tr.join(list.pos);
  return true;
};

var joinListForwards = function joinListForwards(tr, listType) {
  var list = findParentNode(function (node) {
    return node.type === listType;
  })(tr.selection);

  if (!list) {
    return true;
  }

  var after = tr.doc.resolve(list.start).after(list.depth);

  if (after === undefined) {
    return true;
  }

  var nodeAfter = tr.doc.nodeAt(after);
  var canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && canJoin(tr.doc, after);

  if (!canJoinForwards) {
    return true;
  }

  tr.join(after);
  return true;
};

var toggleList = function toggleList(listTypeOrName, itemTypeOrName, keepMarks) {
  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (_ref80) {
    var editor = _ref80.editor,
        tr = _ref80.tr,
        state = _ref80.state,
        dispatch = _ref80.dispatch,
        chain = _ref80.chain,
        commands = _ref80.commands,
        can = _ref80.can;
    var _editor$extensionMana = editor.extensionManager,
        extensions = _editor$extensionMana.extensions,
        splittableMarks = _editor$extensionMana.splittableMarks;
    var listType = getNodeType(listTypeOrName, state.schema);
    var itemType = getNodeType(itemTypeOrName, state.schema);
    var selection = state.selection,
        storedMarks = state.storedMarks;
    var $from = selection.$from,
        $to = selection.$to;
    var range = $from.blockRange($to);
    var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();

    if (!range) {
      return false;
    }

    var parentList = findParentNode(function (node) {
      return isList(node.type.name, extensions);
    })(selection);

    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
      // remove list
      if (parentList.node.type === listType) {
        return commands.liftListItem(itemType);
      } // change list type


      if (isList(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) {
        return chain().command(function () {
          tr.setNodeMarkup(parentList.pos, listType);
          return true;
        }).command(function () {
          return joinListBackwards(tr, listType);
        }).command(function () {
          return joinListForwards(tr, listType);
        }).run();
      }
    }

    if (!keepMarks || !marks || !dispatch) {
      return chain() // try to convert node to default node if needed
      .command(function () {
        var canWrapInList = can().wrapInList(listType, attributes);

        if (canWrapInList) {
          return true;
        }

        return commands.clearNodes();
      }).wrapInList(listType, attributes).command(function () {
        return joinListBackwards(tr, listType);
      }).command(function () {
        return joinListForwards(tr, listType);
      }).run();
    }

    return chain() // try to convert node to default node if needed
    .command(function () {
      var canWrapInList = can().wrapInList(listType, attributes);
      var filteredMarks = marks.filter(function (mark) {
        return splittableMarks.includes(mark.type.name);
      });
      tr.ensureMarks(filteredMarks);

      if (canWrapInList) {
        return true;
      }

      return commands.clearNodes();
    }).wrapInList(listType, attributes).command(function () {
      return joinListBackwards(tr, listType);
    }).command(function () {
      return joinListForwards(tr, listType);
    }).run();
  };
};

var toggleMark = function toggleMark(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (_ref81) {
    var state = _ref81.state,
        commands = _ref81.commands;
    var _options$extendEmptyM = options.extendEmptyMarkRange,
        extendEmptyMarkRange = _options$extendEmptyM === void 0 ? false : _options$extendEmptyM;
    var type = getMarkType(typeOrName, state.schema);
    var isActive = isMarkActive(state, type, attributes);

    if (isActive) {
      return commands.unsetMark(type, {
        extendEmptyMarkRange: extendEmptyMarkRange
      });
    }

    return commands.setMark(type, attributes);
  };
};

var toggleNode = function toggleNode(typeOrName, toggleTypeOrName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (_ref82) {
    var state = _ref82.state,
        commands = _ref82.commands;
    var type = getNodeType(typeOrName, state.schema);
    var toggleType = getNodeType(toggleTypeOrName, state.schema);
    var isActive = isNodeActive(state, type, attributes);

    if (isActive) {
      return commands.setNode(toggleType);
    }

    return commands.setNode(type, attributes);
  };
};

var toggleWrap = function toggleWrap(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref83) {
    var state = _ref83.state,
        commands = _ref83.commands;
    var type = getNodeType(typeOrName, state.schema);
    var isActive = isNodeActive(state, type, attributes);

    if (isActive) {
      return commands.lift(type);
    }

    return commands.wrapIn(type, attributes);
  };
};

var undoInputRule = function undoInputRule() {
  return function (_ref84) {
    var state = _ref84.state,
        dispatch = _ref84.dispatch;
    var plugins = state.plugins;

    for (var i = 0; i < plugins.length; i += 1) {
      var plugin = plugins[i];
      var undoable = void 0; // @ts-ignore
      // eslint-disable-next-line

      if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
        if (dispatch) {
          var tr = state.tr;
          var toUndo = undoable.transform;

          for (var j = toUndo.steps.length - 1; j >= 0; j -= 1) {
            tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
          }

          if (undoable.text) {
            var marks = tr.doc.resolve(undoable.from).marks();
            tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
          } else {
            tr.delete(undoable.from, undoable.to);
          }
        }

        return true;
      }
    }

    return false;
  };
};

var unsetAllMarks = function unsetAllMarks() {
  return function (_ref85) {
    var tr = _ref85.tr,
        dispatch = _ref85.dispatch;
    var selection = tr.selection;
    var empty = selection.empty,
        ranges = selection.ranges;

    if (empty) {
      return true;
    }

    if (dispatch) {
      ranges.forEach(function (range) {
        tr.removeMark(range.$from.pos, range.$to.pos);
      });
    }

    return true;
  };
};

var unsetMark = function unsetMark(typeOrName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref86) {
    var tr = _ref86.tr,
        state = _ref86.state,
        dispatch = _ref86.dispatch;

    var _a;

    var _options$extendEmptyM2 = options.extendEmptyMarkRange,
        extendEmptyMarkRange = _options$extendEmptyM2 === void 0 ? false : _options$extendEmptyM2;
    var selection = tr.selection;
    var type = getMarkType(typeOrName, state.schema);
    var $from = selection.$from,
        empty = selection.empty,
        ranges = selection.ranges;

    if (!dispatch) {
      return true;
    }

    if (empty && extendEmptyMarkRange) {
      var from = selection.from,
          to = selection.to;
      var attrs = (_a = $from.marks().find(function (mark) {
        return mark.type === type;
      })) === null || _a === void 0 ? void 0 : _a.attrs;
      var range = getMarkRange($from, type, attrs);

      if (range) {
        from = range.from;
        to = range.to;
      }

      tr.removeMark(from, to, type);
    } else {
      ranges.forEach(function (range) {
        tr.removeMark(range.$from.pos, range.$to.pos, type);
      });
    }

    tr.removeStoredMark(type);
    return true;
  };
};

var updateAttributes = function updateAttributes(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref87) {
    var tr = _ref87.tr,
        state = _ref87.state,
        dispatch = _ref87.dispatch;
    var nodeType = null;
    var markType = null;
    var schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);

    if (!schemaType) {
      return false;
    }

    if (schemaType === 'node') {
      nodeType = getNodeType(typeOrName, state.schema);
    }

    if (schemaType === 'mark') {
      markType = getMarkType(typeOrName, state.schema);
    }

    if (dispatch) {
      tr.selection.ranges.forEach(function (range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        state.doc.nodesBetween(from, to, function (node, pos) {
          if (nodeType && nodeType === node.type) {
            tr.setNodeMarkup(pos, undefined, _objectSpread(_objectSpread({}, node.attrs), attributes));
          }

          if (markType && node.marks.length) {
            node.marks.forEach(function (mark) {
              if (markType === mark.type) {
                var trimmedFrom = Math.max(pos, from);
                var trimmedTo = Math.min(pos + node.nodeSize, to);
                tr.addMark(trimmedFrom, trimmedTo, markType.create(_objectSpread(_objectSpread({}, mark.attrs), attributes)));
              }
            });
          }
        });
      });
    }

    return true;
  };
};

var wrapIn = function wrapIn(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref88) {
    var state = _ref88.state,
        dispatch = _ref88.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return wrapIn$1(type, attributes)(state, dispatch);
  };
};

var wrapInList = function wrapInList(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref89) {
    var state = _ref89.state,
        dispatch = _ref89.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return wrapInList$1(type, attributes)(state, dispatch);
  };
};

var commands = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blur: blur,
  clearContent: clearContent,
  clearNodes: clearNodes,
  command: command,
  createParagraphNear: createParagraphNear,
  cut: cut,
  deleteCurrentNode: deleteCurrentNode,
  deleteNode: deleteNode,
  deleteRange: deleteRange,
  deleteSelection: deleteSelection,
  enter: enter,
  exitCode: exitCode,
  extendMarkRange: extendMarkRange,
  first: first,
  focus: focus,
  forEach: forEach,
  insertContent: insertContent,
  insertContentAt: insertContentAt,
  joinUp: joinUp,
  joinDown: joinDown,
  joinBackward: joinBackward,
  joinForward: joinForward,
  joinItemBackward: joinItemBackward,
  joinItemForward: joinItemForward,
  keyboardShortcut: keyboardShortcut,
  lift: lift,
  liftEmptyBlock: liftEmptyBlock,
  liftListItem: liftListItem,
  newlineInCode: newlineInCode,
  resetAttributes: resetAttributes,
  scrollIntoView: scrollIntoView,
  selectAll: selectAll,
  selectNodeBackward: selectNodeBackward,
  selectNodeForward: selectNodeForward,
  selectParentNode: selectParentNode,
  selectTextblockEnd: selectTextblockEnd,
  selectTextblockStart: selectTextblockStart,
  setContent: setContent,
  setMark: setMark,
  setMeta: setMeta,
  setNode: setNode,
  setNodeSelection: setNodeSelection,
  setTextSelection: setTextSelection,
  sinkListItem: sinkListItem,
  splitBlock: splitBlock,
  splitListItem: splitListItem,
  toggleList: toggleList,
  toggleMark: toggleMark,
  toggleNode: toggleNode,
  toggleWrap: toggleWrap,
  undoInputRule: undoInputRule,
  unsetAllMarks: unsetAllMarks,
  unsetMark: unsetMark,
  updateAttributes: updateAttributes,
  wrapIn: wrapIn,
  wrapInList: wrapInList
});
var Commands = Extension.create({
  name: 'commands',
  addCommands: function addCommands() {
    return _objectSpread({}, commands);
  }
});
var Editable = Extension.create({
  name: 'editable',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this14 = this;

    return [new Plugin({
      key: new PluginKey('editable'),
      props: {
        editable: function editable() {
          return _this14.editor.options.editable;
        }
      }
    })];
  }
});
var FocusEvents = Extension.create({
  name: 'focusEvents',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var editor = this.editor;
    return [new Plugin({
      key: new PluginKey('focusEvents'),
      props: {
        handleDOMEvents: {
          focus: function focus(view, event) {
            editor.isFocused = true;
            var transaction = editor.state.tr.setMeta('focus', {
              event: event
            }).setMeta('addToHistory', false);
            view.dispatch(transaction);
            return false;
          },
          blur: function blur(view, event) {
            editor.isFocused = false;
            var transaction = editor.state.tr.setMeta('blur', {
              event: event
            }).setMeta('addToHistory', false);
            view.dispatch(transaction);
            return false;
          }
        }
      }
    })];
  }
});
var Keymap = Extension.create({
  name: 'keymap',
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this15 = this;

    var handleBackspace = function handleBackspace() {
      return _this15.editor.commands.first(function (_ref90) {
        var commands = _ref90.commands;
        return [function () {
          return commands.undoInputRule();
        }, // maybe convert first text block node to default node
        function () {
          return commands.command(function (_ref91) {
            var tr = _ref91.tr;
            var selection = tr.selection,
                doc = tr.doc;
            var empty = selection.empty,
                $anchor = selection.$anchor;
            var pos = $anchor.pos,
                parent = $anchor.parent;
            var $parentPos = $anchor.parent.isTextblock ? tr.doc.resolve(pos - 1) : $anchor;
            var parentIsIsolating = $parentPos.parent.type.spec.isolating;
            var parentPos = $anchor.pos - $anchor.parentOffset;
            var isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : Selection.atStart(doc).from === pos;

            if (!empty || !isAtStart || !parent.type.isTextblock || parent.textContent.length) {
              return false;
            }

            return commands.clearNodes();
          });
        }, function () {
          return commands.deleteSelection();
        }, function () {
          return commands.joinBackward();
        }, function () {
          return commands.selectNodeBackward();
        }];
      });
    };

    var handleDelete = function handleDelete() {
      return _this15.editor.commands.first(function (_ref92) {
        var commands = _ref92.commands;
        return [function () {
          return commands.deleteSelection();
        }, function () {
          return commands.deleteCurrentNode();
        }, function () {
          return commands.joinForward();
        }, function () {
          return commands.selectNodeForward();
        }];
      });
    };

    var handleEnter = function handleEnter() {
      return _this15.editor.commands.first(function (_ref93) {
        var commands = _ref93.commands;
        return [function () {
          return commands.newlineInCode();
        }, function () {
          return commands.createParagraphNear();
        }, function () {
          return commands.liftEmptyBlock();
        }, function () {
          return commands.splitBlock();
        }];
      });
    };

    var baseKeymap = {
      Enter: handleEnter,
      'Mod-Enter': function ModEnter() {
        return _this15.editor.commands.exitCode();
      },
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      'Shift-Backspace': handleBackspace,
      Delete: handleDelete,
      'Mod-Delete': handleDelete,
      'Mod-a': function ModA() {
        return _this15.editor.commands.selectAll();
      }
    };

    var pcKeymap = _objectSpread({}, baseKeymap);

    var macKeymap = _objectSpread(_objectSpread({}, baseKeymap), {}, {
      'Ctrl-h': handleBackspace,
      'Alt-Backspace': handleBackspace,
      'Ctrl-d': handleDelete,
      'Ctrl-Alt-Backspace': handleDelete,
      'Alt-Delete': handleDelete,
      'Alt-d': handleDelete,
      'Ctrl-a': function CtrlA() {
        return _this15.editor.commands.selectTextblockStart();
      },
      'Ctrl-e': function CtrlE() {
        return _this15.editor.commands.selectTextblockEnd();
      }
    });

    if (isiOS() || isMacOS()) {
      return macKeymap;
    }

    return pcKeymap;
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this16 = this;

    return [// With this plugin we check if the whole document was selected and deleted.
    // In this case we will additionally call `clearNodes()` to convert e.g. a heading
    // to a paragraph if necessary.
    // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
    // with many other commands.
    new Plugin({
      key: new PluginKey('clearDocument'),
      appendTransaction: function appendTransaction(transactions, oldState, newState) {
        var docChanges = transactions.some(function (transaction) {
          return transaction.docChanged;
        }) && !oldState.doc.eq(newState.doc);

        if (!docChanges) {
          return;
        }

        var _oldState$selection = oldState.selection,
            empty = _oldState$selection.empty,
            from = _oldState$selection.from,
            to = _oldState$selection.to;
        var allFrom = Selection.atStart(oldState.doc).from;
        var allEnd = Selection.atEnd(oldState.doc).to;
        var allWasSelected = from === allFrom && to === allEnd;

        if (empty || !allWasSelected) {
          return;
        }

        var isEmpty = newState.doc.textBetween(0, newState.doc.content.size, ' ', ' ').length === 0;

        if (!isEmpty) {
          return;
        }

        var tr = newState.tr;
        var state = createChainableState({
          state: newState,
          transaction: tr
        });

        var _CommandManager3 = new CommandManager({
          editor: _this16.editor,
          state: state
        }),
            commands = _CommandManager3.commands;

        commands.clearNodes();

        if (!tr.steps.length) {
          return;
        }

        return tr;
      }
    })];
  }
});
var Tabindex = Extension.create({
  name: 'tabindex',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    return [new Plugin({
      key: new PluginKey('tabindex'),
      props: {
        attributes: this.editor.isEditable ? {
          tabindex: '0'
        } : {}
      }
    })];
  }
});
var extensions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: ClipboardTextSerializer,
  Commands: Commands,
  Editable: Editable,
  FocusEvents: FocusEvents,
  Keymap: Keymap,
  Tabindex: Tabindex
});
var style = ".ProseMirror {\n  position: relative;\n}\n\n.ProseMirror {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  white-space: break-spaces;\n  -webkit-font-variant-ligatures: none;\n  font-variant-ligatures: none;\n  font-feature-settings: \"liga\" 0; /* the above doesn't seem to work in Edge */\n}\n\n.ProseMirror [contenteditable=\"false\"] {\n  white-space: normal;\n}\n\n.ProseMirror [contenteditable=\"false\"] [contenteditable=\"true\"] {\n  white-space: pre-wrap;\n}\n\n.ProseMirror pre {\n  white-space: pre-wrap;\n}\n\nimg.ProseMirror-separator {\n  display: inline !important;\n  border: none !important;\n  margin: 0 !important;\n  width: 1px !important;\n  height: 1px !important;\n}\n\n.ProseMirror-gapcursor {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  margin: 0;\n}\n\n.ProseMirror-gapcursor:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;\n}\n\n@keyframes ProseMirror-cursor-blink {\n  to {\n    visibility: hidden;\n  }\n}\n\n.ProseMirror-hideselection *::selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection *::-moz-selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection * {\n  caret-color: transparent;\n}\n\n.ProseMirror-focused .ProseMirror-gapcursor {\n  display: block;\n}\n\n.tippy-box[data-animation=fade][data-state=hidden] {\n  opacity: 0\n}";

function createStyleTag(style, nonce, suffix) {
  var tiptapStyleTag = document.querySelector("style[data-tiptap-style".concat(suffix ? "-".concat(suffix) : '', "]"));

  if (tiptapStyleTag !== null) {
    return tiptapStyleTag;
  }

  var styleNode = document.createElement('style');

  if (nonce) {
    styleNode.setAttribute('nonce', nonce);
  }

  styleNode.setAttribute("data-tiptap-style".concat(suffix ? "-".concat(suffix) : ''), '');
  styleNode.innerHTML = style;
  document.getElementsByTagName('head')[0].appendChild(styleNode);
  return styleNode;
}

var Editor = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Editor, _EventEmitter);

  var _super = _createSuper(Editor);

  function Editor() {
    var _this17;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Editor);

    _this17 = _super.call(this);
    _this17.isFocused = false;
    _this17.extensionStorage = {};
    _this17.options = {
      element: document.createElement('div'),
      content: '',
      injectCSS: true,
      injectNonce: undefined,
      extensions: [],
      autofocus: false,
      editable: true,
      editorProps: {},
      parseOptions: {},
      enableInputRules: true,
      enablePasteRules: true,
      enableCoreExtensions: true,
      onBeforeCreate: function onBeforeCreate() {
        return null;
      },
      onCreate: function onCreate() {
        return null;
      },
      onUpdate: function onUpdate() {
        return null;
      },
      onSelectionUpdate: function onSelectionUpdate() {
        return null;
      },
      onTransaction: function onTransaction() {
        return null;
      },
      onFocus: function onFocus() {
        return null;
      },
      onBlur: function onBlur() {
        return null;
      },
      onDestroy: function onDestroy() {
        return null;
      }
    };
    _this17.isCapturingTransaction = false;
    _this17.capturedTransaction = null;

    _this17.setOptions(options);

    _this17.createExtensionManager();

    _this17.createCommandManager();

    _this17.createSchema();

    _this17.on('beforeCreate', _this17.options.onBeforeCreate);

    _this17.emit('beforeCreate', {
      editor: _assertThisInitialized(_this17)
    });

    _this17.createView();

    _this17.injectCSS();

    _this17.on('create', _this17.options.onCreate);

    _this17.on('update', _this17.options.onUpdate);

    _this17.on('selectionUpdate', _this17.options.onSelectionUpdate);

    _this17.on('transaction', _this17.options.onTransaction);

    _this17.on('focus', _this17.options.onFocus);

    _this17.on('blur', _this17.options.onBlur);

    _this17.on('destroy', _this17.options.onDestroy);

    window.setTimeout(function () {
      if (_this17.isDestroyed) {
        return;
      }

      _this17.commands.focus(_this17.options.autofocus);

      _this17.emit('create', {
        editor: _assertThisInitialized(_this17)
      });
    }, 0);
    return _this17;
  }
  /**
   * Returns the editor storage.
   */


  _createClass(Editor, [{
    key: "storage",
    get: function get() {
      return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */

  }, {
    key: "commands",
    get: function get() {
      return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */

  }, {
    key: "chain",
    value: function chain() {
      return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */

  }, {
    key: "can",
    value: function can() {
      return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */

  }, {
    key: "injectCSS",
    value: function injectCSS() {
      if (this.options.injectCSS && document) {
        this.css = createStyleTag(style, this.options.injectNonce);
      }
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */

  }, {
    key: "setOptions",
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options = _objectSpread(_objectSpread({}, this.options), options);

      if (!this.view || !this.state || this.isDestroyed) {
        return;
      }

      if (this.options.editorProps) {
        this.view.setProps(this.options.editorProps);
      }

      this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */

  }, {
    key: "setEditable",
    value: function setEditable(editable) {
      var emitUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.setOptions({
        editable: editable
      });

      if (emitUpdate) {
        this.emit('update', {
          editor: this,
          transaction: this.state.tr
        });
      }
    }
    /**
     * Returns whether the editor is editable.
     */

  }, {
    key: "isEditable",
    get: function get() {
      // since plugins are applied after creating the view
      // `editable` is always `true` for one tick.
      // that’s why we also have to check for `options.editable`
      return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */

  }, {
    key: "state",
    get: function get() {
      return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     */

  }, {
    key: "registerPlugin",
    value: function registerPlugin(plugin, handlePlugins) {
      var plugins = isFunction(handlePlugins) ? handlePlugins(plugin, _toConsumableArray(this.state.plugins)) : [].concat(_toConsumableArray(this.state.plugins), [plugin]);
      var state = this.state.reconfigure({
        plugins: plugins
      });
      this.view.updateState(state);
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKey The plugins name
     */

  }, {
    key: "unregisterPlugin",
    value: function unregisterPlugin(nameOrPluginKey) {
      if (this.isDestroyed) {
        return;
      } // @ts-ignore


      var name = typeof nameOrPluginKey === 'string' ? "".concat(nameOrPluginKey, "$") : nameOrPluginKey.key;
      var state = this.state.reconfigure({
        // @ts-ignore
        plugins: this.state.plugins.filter(function (plugin) {
          return !plugin.key.startsWith(name);
        })
      });
      this.view.updateState(state);
    }
    /**
     * Creates an extension manager.
     */

  }, {
    key: "createExtensionManager",
    value: function createExtensionManager() {
      var coreExtensions = this.options.enableCoreExtensions ? Object.values(extensions) : [];
      var allExtensions = [].concat(_toConsumableArray(coreExtensions), _toConsumableArray(this.options.extensions)).filter(function (extension) {
        return ['extension', 'node', 'mark'].includes(extension === null || extension === void 0 ? void 0 : extension.type);
      });
      this.extensionManager = new ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */

  }, {
    key: "createCommandManager",
    value: function createCommandManager() {
      this.commandManager = new CommandManager({
        editor: this
      });
    }
    /**
     * Creates a ProseMirror schema.
     */

  }, {
    key: "createSchema",
    value: function createSchema() {
      this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */

  }, {
    key: "createView",
    value: function createView() {
      var doc = createDocument(this.options.content, this.schema, this.options.parseOptions);
      var selection = resolveFocusPosition(doc, this.options.autofocus);
      this.view = new EditorView(this.options.element, _objectSpread(_objectSpread({}, this.options.editorProps), {}, {
        dispatchTransaction: this.dispatchTransaction.bind(this),
        state: EditorState.create({
          doc: doc,
          selection: selection || undefined
        })
      })); // `editor.view` is not yet available at this time.
      // Therefore we will add all plugins and node views directly afterwards.

      var newState = this.state.reconfigure({
        plugins: this.extensionManager.plugins
      });
      this.view.updateState(newState);
      this.createNodeViews();
      this.prependClass(); // Let’s store the editor instance in the DOM element.
      // So we’ll have access to it for tests.

      var dom = this.view.dom;
      dom.editor = this;
    }
    /**
     * Creates all node views.
     */

  }, {
    key: "createNodeViews",
    value: function createNodeViews() {
      this.view.setProps({
        nodeViews: this.extensionManager.nodeViews
      });
    }
    /**
     * Prepend class name to element.
     */

  }, {
    key: "prependClass",
    value: function prependClass() {
      this.view.dom.className = "tiptap ".concat(this.view.dom.className);
    }
  }, {
    key: "captureTransaction",
    value: function captureTransaction(fn) {
      this.isCapturingTransaction = true;
      fn();
      this.isCapturingTransaction = false;
      var tr = this.capturedTransaction;
      this.capturedTransaction = null;
      return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */

  }, {
    key: "dispatchTransaction",
    value: function dispatchTransaction(transaction) {
      var _this18 = this;

      // if the editor / the view of the editor was destroyed
      // the transaction should not be dispatched as there is no view anymore.
      if (this.view.isDestroyed) {
        return;
      }

      if (this.isCapturingTransaction) {
        if (!this.capturedTransaction) {
          this.capturedTransaction = transaction;
          return;
        }

        transaction.steps.forEach(function (step) {
          var _a;

          return (_a = _this18.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
        });
        return;
      }

      var state = this.state.apply(transaction);
      var selectionHasChanged = !this.state.selection.eq(state.selection);
      this.view.updateState(state);
      this.emit('transaction', {
        editor: this,
        transaction: transaction
      });

      if (selectionHasChanged) {
        this.emit('selectionUpdate', {
          editor: this,
          transaction: transaction
        });
      }

      var focus = transaction.getMeta('focus');
      var blur = transaction.getMeta('blur');

      if (focus) {
        this.emit('focus', {
          editor: this,
          event: focus.event,
          transaction: transaction
        });
      }

      if (blur) {
        this.emit('blur', {
          editor: this,
          event: blur.event,
          transaction: transaction
        });
      }

      if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
        return;
      }

      this.emit('update', {
        editor: this,
        transaction: transaction
      });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */

  }, {
    key: "getAttributes",
    value: function getAttributes(nameOrType) {
      return _getAttributes(this.state, nameOrType);
    }
  }, {
    key: "isActive",
    value: function isActive(nameOrAttributes, attributesOrUndefined) {
      var name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
      var attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
      return _isActive(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */

  }, {
    key: "getJSON",
    value: function getJSON() {
      return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */

  }, {
    key: "getHTML",
    value: function getHTML() {
      return getHTMLFromFragment(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */

  }, {
    key: "getText",
    value: function getText(options) {
      var _ref94 = options || {},
          _ref94$blockSeparator = _ref94.blockSeparator,
          blockSeparator = _ref94$blockSeparator === void 0 ? '\n\n' : _ref94$blockSeparator,
          _ref94$textSerializer = _ref94.textSerializers,
          textSerializers = _ref94$textSerializer === void 0 ? {} : _ref94$textSerializer;

      return _getText(this.state.doc, {
        blockSeparator: blockSeparator,
        textSerializers: _objectSpread(_objectSpread({}, getTextSerializersFromSchema(this.schema)), textSerializers)
      });
    }
    /**
     * Check if there is no content.
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return isNodeEmpty(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */

  }, {
    key: "getCharacterCount",
    value: function getCharacterCount() {
      console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
      return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.emit('destroy');

      if (this.view) {
        this.view.destroy();
      }

      this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */

  }, {
    key: "isDestroyed",
    get: function get() {
      var _a; // @ts-ignore


      return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
  }]);

  return Editor;
}(EventEmitter);
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 */


function markInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref95) {
      var state = _ref95.state,
          range = _ref95.range,
          match = _ref95.match;
      var attributes = callOrReturn(config.getAttributes, undefined, match);

      if (attributes === false || attributes === null) {
        return null;
      }

      var tr = state.tr;
      var captureGroup = match[match.length - 1];
      var fullMatch = match[0];

      if (captureGroup) {
        var startSpaces = fullMatch.search(/\S/);
        var textStart = range.from + fullMatch.indexOf(captureGroup);
        var textEnd = textStart + captureGroup.length;
        var excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter(function (item) {
          // @ts-ignore
          var excluded = item.mark.type.excluded;
          return excluded.find(function (type) {
            return type === config.type && type !== item.mark.type;
          });
        }).filter(function (item) {
          return item.to > textStart;
        });

        if (excludedMarks.length) {
          return null;
        }

        if (textEnd < range.to) {
          tr.delete(textEnd, range.to);
        }

        if (textStart > range.from) {
          tr.delete(range.from + startSpaces, textStart);
        }

        var markEnd = range.from + startSpaces + captureGroup.length;
        tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
        tr.removeStoredMark(config.type);
      }
    }
  });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 */


function nodeInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref96) {
      var state = _ref96.state,
          range = _ref96.range,
          match = _ref96.match;
      var attributes = callOrReturn(config.getAttributes, undefined, match) || {};
      var tr = state.tr;
      var start = range.from;
      var end = range.to;
      var newNode = config.type.create(attributes);

      if (match[1]) {
        var offset = match[0].lastIndexOf(match[1]);
        var matchStart = start + offset;

        if (matchStart > end) {
          matchStart = end;
        } else {
          end = matchStart + match[1].length;
        } // insert last typed character


        var lastChar = match[0][match[0].length - 1];
        tr.insertText(lastChar, start + match[0].length - 1); // insert node from input rule

        tr.replaceWith(matchStart, end, newNode);
      } else if (match[0]) {
        tr.insert(start - 1, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
      }

      tr.scrollIntoView();
    }
  });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 */


function textblockTypeInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref97) {
      var state = _ref97.state,
          range = _ref97.range,
          match = _ref97.match;
      var $start = state.doc.resolve(range.from);
      var attributes = callOrReturn(config.getAttributes, undefined, match) || {};

      if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) {
        return null;
      }

      state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
    }
  });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 */


function textInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref98) {
      var state = _ref98.state,
          range = _ref98.range,
          match = _ref98.match;
      var insert = config.replace;
      var start = range.from;
      var end = range.to;

      if (match[1]) {
        var offset = match[0].lastIndexOf(match[1]);
        insert += match[0].slice(offset + match[1].length);
        start += offset;
        var cutOff = start - end;

        if (cutOff > 0) {
          insert = match[0].slice(offset - cutOff, offset) + insert;
          start = end;
        }
      }

      state.tr.insertText(insert, start, end);
    }
  });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 */


function wrappingInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref99) {
      var state = _ref99.state,
          range = _ref99.range,
          match = _ref99.match,
          chain = _ref99.chain;
      var attributes = callOrReturn(config.getAttributes, undefined, match) || {};
      var tr = state.tr.delete(range.from, range.to);
      var $start = tr.doc.resolve(range.from);
      var blockRange = $start.blockRange();
      var wrapping = blockRange && findWrapping(blockRange, config.type, attributes);

      if (!wrapping) {
        return null;
      }

      tr.wrap(blockRange, wrapping);

      if (config.keepMarks && config.editor) {
        var selection = state.selection,
            storedMarks = state.storedMarks;
        var splittableMarks = config.editor.extensionManager.splittableMarks;
        var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();

        if (marks) {
          var filteredMarks = marks.filter(function (mark) {
            return splittableMarks.includes(mark.type.name);
          });
          tr.ensureMarks(filteredMarks);
        }
      }

      if (config.keepAttributes) {
        /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */
        var nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
        chain().updateAttributes(nodeType, attributes).run();
      }

      var before = tr.doc.resolve(range.from - 1).nodeBefore;

      if (before && before.type === config.type && canJoin(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) {
        tr.join(range.from - 1);
      }
    }
  });
}

var Mark = /*#__PURE__*/function () {
  function Mark() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Mark);

    this.type = 'mark';
    this.name = 'mark';
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.name = this.config.name;

    if (config.defaultOptions) {
      console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(this.name, "\"."));
    } // TODO: remove `addOptions` fallback


    this.options = this.config.defaultOptions;

    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, 'addOptions', {
        name: this.name
      }));
    }

    this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
      name: this.name,
      options: this.options
    })) || {};
  }

  _createClass(Mark, [{
    key: "configure",
    value: function configure() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // return a new instance so we can use the same extension
      // with different calls of `configure`
      var extension = this.extend();
      extension.options = mergeDeep(this.options, options);
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extendedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extension = new Mark(extendedConfig);
      extension.parent = this;
      this.child = extension;
      extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;

      if (extendedConfig.defaultOptions) {
        console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(extension.name, "\"."));
      }

      extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
        name: extension.name
      }));
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }], [{
    key: "create",
    value: function create() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Mark(config);
    }
  }, {
    key: "handleExit",
    value: function handleExit(_ref100) {
      var editor = _ref100.editor,
          mark = _ref100.mark;
      var tr = editor.state.tr;
      var currentPos = editor.state.selection.$from;
      var isAtEnd = currentPos.pos === currentPos.end();

      if (isAtEnd) {
        var currentMarks = currentPos.marks();
        var isInMark = !!currentMarks.find(function (m) {
          return (m === null || m === void 0 ? void 0 : m.type.name) === mark.name;
        });

        if (!isInMark) {
          return false;
        }

        var removeMark = currentMarks.find(function (m) {
          return (m === null || m === void 0 ? void 0 : m.type.name) === mark.name;
        });

        if (removeMark) {
          tr.removeStoredMark(removeMark);
        }

        tr.insertText(' ', currentPos.pos);
        editor.view.dispatch(tr);
        return true;
      }

      return false;
    }
  }]);

  return Mark;
}();

var Node = /*#__PURE__*/function () {
  function Node() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Node);

    this.type = 'node';
    this.name = 'node';
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.name = this.config.name;

    if (config.defaultOptions) {
      console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(this.name, "\"."));
    } // TODO: remove `addOptions` fallback


    this.options = this.config.defaultOptions;

    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, 'addOptions', {
        name: this.name
      }));
    }

    this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
      name: this.name,
      options: this.options
    })) || {};
  }

  _createClass(Node, [{
    key: "configure",
    value: function configure() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // return a new instance so we can use the same extension
      // with different calls of `configure`
      var extension = this.extend();
      extension.options = mergeDeep(this.options, options);
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extendedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extension = new Node(extendedConfig);
      extension.parent = this;
      this.child = extension;
      extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;

      if (extendedConfig.defaultOptions) {
        console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(extension.name, "\"."));
      }

      extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
        name: extension.name
      }));
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }], [{
    key: "create",
    value: function create() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Node(config);
    }
  }]);

  return Node;
}();

function isAndroid() {
  return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}

var NodeView = /*#__PURE__*/function () {
  function NodeView(component, props, options) {
    _classCallCheck(this, NodeView);

    this.isDragging = false;
    this.component = component;
    this.editor = props.editor;
    this.options = _objectSpread({
      stopEvent: null,
      ignoreMutation: null
    }, options);
    this.extension = props.extension;
    this.node = props.node;
    this.decorations = props.decorations;
    this.getPos = props.getPos;
    this.mount();
  }

  _createClass(NodeView, [{
    key: "mount",
    value: function mount() {
      // eslint-disable-next-line
      return;
    }
  }, {
    key: "dom",
    get: function get() {
      return this.editor.view.dom;
    }
  }, {
    key: "contentDOM",
    get: function get() {
      return null;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(event) {
      var _a, _b, _c, _d, _e, _f, _g;

      var view = this.editor.view;
      var target = event.target; // get the drag handle element
      // `closest` is not available for text nodes so we may have to use its parent

      var dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]') : target.closest('[data-drag-handle]');

      if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) {
        return;
      }

      var x = 0;
      var y = 0; // calculate offset for drag element if we use a different drag handle element

      if (this.dom !== dragHandle) {
        var domBox = this.dom.getBoundingClientRect();
        var handleBox = dragHandle.getBoundingClientRect(); // In React, we have to go through nativeEvent to reach offsetX/offsetY.

        var offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
        var offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
        x = handleBox.x - domBox.x + offsetX;
        y = handleBox.y - domBox.y + offsetY;
      }

      (_g = event.dataTransfer) === null || _g === void 0 ? void 0 : _g.setDragImage(this.dom, x, y); // we need to tell ProseMirror that we want to move the whole node
      // so we create a NodeSelection

      var selection = NodeSelection.create(view.state.doc, this.getPos());
      var transaction = view.state.tr.setSelection(selection);
      view.dispatch(transaction);
    }
  }, {
    key: "stopEvent",
    value: function stopEvent(event) {
      var _this19 = this;

      var _a;

      if (!this.dom) {
        return false;
      }

      if (typeof this.options.stopEvent === 'function') {
        return this.options.stopEvent({
          event: event
        });
      }

      var target = event.target;
      var isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target)); // any event from child nodes should be handled by ProseMirror

      if (!isInElement) {
        return false;
      }

      var isDragEvent = event.type.startsWith('drag');
      var isDropEvent = event.type === 'drop';
      var isInput = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable; // any input event within node views should be ignored by ProseMirror

      if (isInput && !isDropEvent && !isDragEvent) {
        return true;
      }

      var isEditable = this.editor.isEditable;
      var isDragging = this.isDragging;
      var isDraggable = !!this.node.type.spec.draggable;
      var isSelectable = NodeSelection.isSelectable(this.node);
      var isCopyEvent = event.type === 'copy';
      var isPasteEvent = event.type === 'paste';
      var isCutEvent = event.type === 'cut';
      var isClickEvent = event.type === 'mousedown'; // ProseMirror tries to drag selectable nodes
      // even if `draggable` is set to `false`
      // this fix prevents that

      if (!isDraggable && isSelectable && isDragEvent) {
        event.preventDefault();
      }

      if (isDraggable && isDragEvent && !isDragging) {
        event.preventDefault();
        return false;
      } // we have to store that dragging started


      if (isDraggable && isEditable && !isDragging && isClickEvent) {
        var dragHandle = target.closest('[data-drag-handle]');
        var isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));

        if (isValidDragHandle) {
          this.isDragging = true;
          document.addEventListener('dragend', function () {
            _this19.isDragging = false;
          }, {
            once: true
          });
          document.addEventListener('drop', function () {
            _this19.isDragging = false;
          }, {
            once: true
          });
          document.addEventListener('mouseup', function () {
            _this19.isDragging = false;
          }, {
            once: true
          });
        }
      } // these events are handled by prosemirror


      if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) {
        return false;
      }

      return true;
    }
  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      if (!this.dom || !this.contentDOM) {
        return true;
      }

      if (typeof this.options.ignoreMutation === 'function') {
        return this.options.ignoreMutation({
          mutation: mutation
        });
      } // a leaf/atom node is like a black box for ProseMirror
      // and should be fully handled by the node view


      if (this.node.isLeaf || this.node.isAtom) {
        return true;
      } // ProseMirror should handle any selections


      if (mutation.type === 'selection') {
        return false;
      } // try to prevent a bug on iOS and Android that will break node views on enter
      // this is because ProseMirror can’t preventDispatch on enter
      // this will lead to a re-render of the node view on enter
      // see: https://github.com/ueberdosis/tiptap/issues/1214
      // see: https://github.com/ueberdosis/tiptap/issues/2534


      if (this.dom.contains(mutation.target) && mutation.type === 'childList' && (isiOS() || isAndroid()) && this.editor.isFocused) {
        var changedNodes = [].concat(_toConsumableArray(Array.from(mutation.addedNodes)), _toConsumableArray(Array.from(mutation.removedNodes))); // we’ll check if every changed node is contentEditable
        // to make sure it’s probably mutated by ProseMirror

        if (changedNodes.every(function (node) {
          return node.isContentEditable;
        })) {
          return false;
        }
      } // we will allow mutation contentDOM with attributes
      // so we can for example adding classes within our node view


      if (this.contentDOM === mutation.target && mutation.type === 'attributes') {
        return true;
      } // ProseMirror should handle any changes within contentDOM


      if (this.contentDOM.contains(mutation.target)) {
        return false;
      }

      return true;
    }
  }, {
    key: "updateAttributes",
    value: function updateAttributes(attributes) {
      var _this20 = this;

      this.editor.commands.command(function (_ref101) {
        var tr = _ref101.tr;

        var pos = _this20.getPos();

        tr.setNodeMarkup(pos, undefined, _objectSpread(_objectSpread({}, _this20.node.attrs), attributes));
        return true;
      });
    }
  }, {
    key: "deleteNode",
    value: function deleteNode() {
      var from = this.getPos();
      var to = from + this.node.nodeSize;
      this.editor.commands.deleteRange({
        from: from,
        to: to
      });
    }
  }]);

  return NodeView;
}();
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 */


function markPasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: function handler(_ref102) {
      var state = _ref102.state,
          range = _ref102.range,
          match = _ref102.match;
      var attributes = callOrReturn(config.getAttributes, undefined, match);

      if (attributes === false || attributes === null) {
        return null;
      }

      var tr = state.tr;
      var captureGroup = match[match.length - 1];
      var fullMatch = match[0];
      var markEnd = range.to;

      if (captureGroup) {
        var startSpaces = fullMatch.search(/\S/);
        var textStart = range.from + fullMatch.indexOf(captureGroup);
        var textEnd = textStart + captureGroup.length;
        var excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter(function (item) {
          // @ts-ignore
          var excluded = item.mark.type.excluded;
          return excluded.find(function (type) {
            return type === config.type && type !== item.mark.type;
          });
        }).filter(function (item) {
          return item.to > textStart;
        });

        if (excludedMarks.length) {
          return null;
        }

        if (textEnd < range.to) {
          tr.delete(textEnd, range.to);
        }

        if (textStart > range.from) {
          tr.delete(range.from + startSpaces, textStart);
        }

        markEnd = range.from + startSpaces + captureGroup.length;
        tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
        tr.removeStoredMark(config.type);
      }
    }
  });
} // source: https://stackoverflow.com/a/6969486


function escapeForRegEx(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isString(value) {
  return typeof value === 'string';
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 */


function nodePasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: function handler(_ref103) {
      var match = _ref103.match,
          chain = _ref103.chain,
          range = _ref103.range;
      var attributes = callOrReturn(config.getAttributes, undefined, match);

      if (attributes === false || attributes === null) {
        return null;
      }

      if (match.input) {
        chain().deleteRange(range).insertContentAt(range.from, {
          type: config.type.name,
          attrs: attributes
        });
      }
    }
  });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 */


function textPasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: function handler(_ref104) {
      var state = _ref104.state,
          range = _ref104.range,
          match = _ref104.match;
      var insert = config.replace;
      var start = range.from;
      var end = range.to;

      if (match[1]) {
        var offset = match[0].lastIndexOf(match[1]);
        insert += match[0].slice(offset + match[1].length);
        start += offset;
        var cutOff = start - end;

        if (cutOff > 0) {
          insert = match[0].slice(offset - cutOff, offset) + insert;
          start = end;
        }
      }

      state.tr.insertText(insert, start, end);
    }
  });
}

var Tracker = /*#__PURE__*/function () {
  function Tracker(transaction) {
    _classCallCheck(this, Tracker);

    this.transaction = transaction;
    this.currentStep = this.transaction.steps.length;
  }

  _createClass(Tracker, [{
    key: "map",
    value: function map(position) {
      var deleted = false;
      var mappedPosition = this.transaction.steps.slice(this.currentStep).reduce(function (newPosition, step) {
        var mapResult = step.getMap().mapResult(newPosition);

        if (mapResult.deleted) {
          deleted = true;
        }

        return mapResult.pos;
      }, position);
      return {
        position: mappedPosition,
        deleted: deleted
      };
    }
  }]);

  return Tracker;
}();

export { CommandManager, Editor, Extension, InputRule, Mark, Node, NodeView, PasteRule, Tracker, callOrReturn, combineTransactionSteps, createChainableState, createDocument, createNodeFromContent, createStyleTag, defaultBlockAt, deleteProps, elementFromString, escapeForRegEx, extensions, findChildren, findChildrenInRange, findDuplicates, findParentNode, findParentNodeClosestToPos, fromString, generateHTML, generateJSON, generateText, _getAttributes as getAttributes, getAttributesFromExtensions, getChangedRanges, getDebugJSON, getExtensionField, getHTMLFromFragment, getMarkAttributes, getMarkRange, getMarkType, getMarksBetween, getNodeAtPosition, getNodeAttributes, getNodeType, getRenderedAttributes, getSchema, getSchemaByResolvedExtensions, getSchemaTypeByName, getSchemaTypeNameByName, getSplittedAttributes, _getText as getText, getTextBetween, getTextContentFromNodes, getTextSerializersFromSchema, injectExtensionAttributesToParseRule, inputRulesPlugin, _isActive as isActive, isAtEndOfNode, isAtStartOfNode, isEmptyObject, isExtensionRulesEnabled, isFunction, isList, isMacOS, isMarkActive, isNodeActive, isNodeEmpty, isNodeSelection, isNumber, isPlainObject, isRegExp, isString, isTextSelection, isiOS, markInputRule, markPasteRule, mergeAttributes, mergeDeep, minMax, nodeInputRule, nodePasteRule, objectIncludes, pasteRulesPlugin, posToDOMRect, removeDuplicates, resolveFocusPosition, selectionToInsertionEnd, splitExtensions, textInputRule, textPasteRule, textblockTypeInputRule, wrappingInputRule };